// @generated by web/tools/codegen — DO NOT EDIT
// Source: apps/public/messages/zh-HK.json (all locales parity-gated at codegen).
// Regenerate: pnpm codegen i18n-keys

/** All namespace prefixes used with useTranslations(). */
export type MessageNamespace =
  | 'about'
  | 'about.contact'
  | 'about.imageGrid'
  | 'about.imageGrid.photoAlt'
  | 'about.seo'
  | 'about.team'
  | 'about.team.bios'
  | 'about.team.roles'
  | 'auth'
  | 'auth.google'
  | 'auth.modal'
  | 'auth.otp'
  | 'auth.shared'
  | 'blog'
  | 'blog.preview'
  | 'common'
  | 'common.a11y'
  | 'contact'
  | 'contact.channel'
  | 'contact.elsewhere'
  | 'contact.include'
  | 'contact.seo'
  | 'contact.topics'
  | 'conversations'
  | 'conversations.composer'
  | 'conversations.dayLabel'
  | 'conversations.empty'
  | 'conversations.message'
  | 'conversations.systemEvent'
  | 'error'
  | 'error.auth'
  | 'error.conversations'
  | 'error.feedbacks'
  | 'error.leads'
  | 'error.listings'
  | 'error.payments'
  | 'error.saved'
  | 'error.storefront'
  | 'error.support'
  | 'estates'
  | 'estates.card'
  | 'estates.detail'
  | 'estates.detail.buildings'
  | 'estates.detail.census'
  | 'estates.detail.census.attribution'
  | 'estates.detail.census.table'
  | 'estates.detail.facts'
  | 'estates.detail.facts.poi'
  | 'estates.detail.faqs'
  | 'estates.detail.gallery'
  | 'estates.detail.priceTrend'
  | 'estates.districtFacet'
  | 'estates.districtFacet.about'
  | 'estates.districtFacet.aboutEmpty'
  | 'estates.districtFacet.guidance'
  | 'feedback'
  | 'feedback.instead'
  | 'feedback.seo'
  | 'feedback.useful'
  | 'feedback.whatHappens'
  | 'forms'
  | 'forms.disclaimer'
  | 'forms.disclaimer.paragraphs'
  | 'forms.documents'
  | 'forms.documents.carParkLeaseAgreement'
  | 'forms.documents.completeRentalChecklist'
  | 'forms.documents.incomeProofSalaried'
  | 'forms.documents.incomeProofSelfEmployed'
  | 'forms.documents.provisionalTenancyAgreement'
  | 'forms.documents.surrenderAgreement'
  | 'forms.seo'
  | 'help'
  | 'help.contactFeedback'
  | 'help.contactFeedback.contact'
  | 'help.contactFeedback.feedback'
  | 'help.links'
  | 'help.seo'
  | 'home'
  | 'home.faqs'
  | 'home.faqs.items'
  | 'home.faqs.items.hardSell'
  | 'home.faqs.items.propertyTypes'
  | 'home.faqs.items.whatIsLgh'
  | 'home.hero'
  | 'home.hero.searchExamples'
  | 'home.tips'
  | 'home.whyUs'
  | 'home.whyUs.serveNotSell'
  | 'home.whyUs.valueForMoney'
  | 'inquiry'
  | 'inquiry.errors'
  | 'legal'
  | 'legal.privacyPolicy'
  | 'legal.privacyPolicy.personalInformation'
  | 'legal.privacyPolicy.propertyInformation'
  | 'legal.privacyPolicy.seo'
  | 'legal.privacyPolicy.siteProtection'
  | 'legal.privacyPolicy.usages'
  | 'legal.termsOfService'
  | 'legal.termsOfService.seo'
  | 'listings'
  | 'listings.browse'
  | 'listings.card'
  | 'listings.carousel'
  | 'listings.dashboard'
  | 'listings.dashboard.empty'
  | 'listings.detail'
  | 'listings.detail.about'
  | 'listings.editor'
  | 'listings.editor.actions'
  | 'listings.editor.sections'
  | 'listings.filters'
  | 'listings.gallery'
  | 'listings.new'
  | 'listings.new.steps'
  | 'listings.new.steps.0'
  | 'listings.new.steps.1'
  | 'listings.new.steps.2'
  | 'listings.sort'
  | 'listings.typeFacet'
  | 'market'
  | 'market.attribution'
  | 'messages'
  | 'messages.signed'
  | 'messages.signed.out'
  | 'nav'
  | 'nav.account'
  | 'nav.footer'
  | 'nav.footer.groups'
  | 'nav.footer.legal'
  | 'nav.footer.links'
  | 'pageTitles'
  | 'pager'
  | 'partners'
  | 'partners.about'
  | 'partners.directory'
  | 'partners.directory.how'
  | 'partners.howToJoin'
  | 'partners.readGuides'
  | 'pets'
  | 'pets.policy'
  | 'preferences'
  | 'preferences.autoTranslate'
  | 'preferences.currency'
  | 'preferences.currency.options'
  | 'preferences.language'
  | 'preferences.unitSystem'
  | 'preferences.unitSystem.options'
  | 'profile'
  | 'profile.list'
  | 'profile.list.property'
  | 'profile.signed'
  | 'profile.signed.out'
  | 'saved'
  | 'saved.empty'
  | 'saved.signed'
  | 'saved.signed.out'
  | 'schoolsAndRentals'
  | 'schoolsAndRentals.dataAccuracy'
  | 'schoolsAndRentals.disclaimerSection'
  | 'schoolsAndRentals.faqs'
  | 'schoolsAndRentals.faqs.list'
  | 'schoolsAndRentals.faqs.list.0'
  | 'schoolsAndRentals.faqs.list.1'
  | 'schoolsAndRentals.faqs.list.2'
  | 'schoolsAndRentals.faqs.list.3'
  | 'schoolsAndRentals.faqs.list.4'
  | 'schoolsAndRentals.peaceOfMind'
  | 'schoolsAndRentals.rentalListings'
  | 'schoolsAndRentals.seo'
  | 'schoolsAndRentals.whyChoose'
  | 'schoolsAndRentals.whyChoose.details'
  | 'search'
  | 'search.sections'
  | 'search.suggestions'
  | 'services'
  | 'services.buyRent'
  | 'services.buyRent.assisted'
  | 'services.buyRent.assisted.features'
  | 'services.buyRent.self'
  | 'services.buyRent.self.features'
  | 'services.faqs'
  | 'services.faqs.list'
  | 'services.faqs.list.0'
  | 'services.faqs.list.1'
  | 'services.faqs.list.2'
  | 'services.faqs.list.3'
  | 'services.sellLease'
  | 'services.sellLease.assisted'
  | 'services.sellLease.assisted.features'
  | 'services.sellLease.self'
  | 'services.sellLease.self.features'
  | 'services.seo'
  | 'services.socialProof'
  | 'services.socialProof.testimonials'
  | 'services.socialProof.testimonials.0'
  | 'services.socialProof.testimonials.1'
  | 'services.socialProof.testimonials.2'
  | 'services.socialProof.testimonials.3'
  | 'services.socialProof.testimonials.4'
  | 'services.tabs'
  | 'settings'
  | 'settings.autoTranslate'
  | 'settings.first_name'
  | 'settings.last_name'
  | 'settings.notifications'
  | 'settings.notifications.email'
  | 'settings.notifications.push'
  | 'settings.notifications.sms'
  | 'settings.notifications.whatsapp'
  | 'settings.personal'
  | 'settings.phone'
  | 'settings.phone.change'
  | 'support'
  | 'support.category'
  | 'support.errors'
  | 'support.message'
  | 'support.seo'
  | 'tools'
  | 'tools.affordability'
  | 'tools.affordability.advantages'
  | 'tools.affordability.advantages.points'
  | 'tools.affordability.calculator'
  | 'tools.affordability.explainer'
  | 'tools.affordability.explainer.blocks'
  | 'tools.affordability.explainer.blocks.0'
  | 'tools.affordability.explainer.blocks.1'
  | 'tools.affordability.explainer.blocks.2'
  | 'tools.affordability.explainer.blocks.3'
  | 'tools.affordability.faqs'
  | 'tools.affordability.faqs.list'
  | 'tools.affordability.faqs.list.0'
  | 'tools.affordability.faqs.list.1'
  | 'tools.affordability.faqs.list.2'
  | 'tools.affordability.faqs.list.3'
  | 'tools.affordability.faqs.list.4'
  | 'tools.affordability.faqs.list.5'
  | 'tools.affordability.howToUse'
  | 'tools.affordability.howToUse.steps'
  | 'tools.affordability.related'
  | 'tools.affordability.results'
  | 'tools.affordability.seo'
  | 'tools.buyVsRent'
  | 'tools.buyVsRent.analysisTool'
  | 'tools.buyVsRent.analysisTool.buyingCost'
  | 'tools.buyVsRent.analysisTool.rentingCost'
  | 'tools.buyVsRent.buyOrRent'
  | 'tools.buyVsRent.disclaimer'
  | 'tools.buyVsRent.fields'
  | 'tools.buyVsRent.howToUse'
  | 'tools.buyVsRent.makeDecisionSmart'
  | 'tools.buyVsRent.needMoreAssistance'
  | 'tools.buyVsRent.readyToExplore'
  | 'tools.buyVsRent.seo'
  | 'tools.chineseConverter'
  | 'tools.chineseConverter.advantages'
  | 'tools.chineseConverter.converter'
  | 'tools.chineseConverter.footerNote'
  | 'tools.chineseConverter.howToUse'
  | 'tools.chineseConverter.seo'
  | 'tools.index'
  | 'tools.index.affordability'
  | 'tools.index.buyVsRent'
  | 'tools.index.calculators'
  | 'tools.index.chineseConverter'
  | 'tools.index.cta'
  | 'tools.index.mortgage'
  | 'tools.index.ratesRent'
  | 'tools.index.rentalYield'
  | 'tools.index.seo'
  | 'tools.index.stampDuty'
  | 'tools.index.templates'
  | 'tools.index.templates.carPark'
  | 'tools.index.templates.incomeProofSalaried'
  | 'tools.index.templates.incomeProofSelf'
  | 'tools.index.templates.rentalChecklist'
  | 'tools.index.templates.surrenderAgreement'
  | 'tools.index.templates.tenancyAgreement'
  | 'tools.mortgage'
  | 'tools.mortgage.advantages'
  | 'tools.mortgage.advantages.points'
  | 'tools.mortgage.calculator'
  | 'tools.mortgage.explainer'
  | 'tools.mortgage.explainer.blocks'
  | 'tools.mortgage.explainer.blocks.0'
  | 'tools.mortgage.explainer.blocks.1'
  | 'tools.mortgage.explainer.blocks.2'
  | 'tools.mortgage.explainer.blocks.3'
  | 'tools.mortgage.explainer.blocks.4'
  | 'tools.mortgage.explainer.blocks.5'
  | 'tools.mortgage.explainer.blocks.6'
  | 'tools.mortgage.faqs'
  | 'tools.mortgage.faqs.list'
  | 'tools.mortgage.faqs.list.0'
  | 'tools.mortgage.faqs.list.1'
  | 'tools.mortgage.faqs.list.2'
  | 'tools.mortgage.faqs.list.3'
  | 'tools.mortgage.faqs.list.4'
  | 'tools.mortgage.faqs.list.5'
  | 'tools.mortgage.faqs.list.6'
  | 'tools.mortgage.faqs.list.7'
  | 'tools.mortgage.howToUse'
  | 'tools.mortgage.howToUse.steps'
  | 'tools.mortgage.related'
  | 'tools.mortgage.results'
  | 'tools.mortgage.seo'
  | 'tools.ratesGovernmentRent'
  | 'tools.ratesGovernmentRent.calculation'
  | 'tools.ratesGovernmentRent.calculation.rateableValue'
  | 'tools.ratesGovernmentRent.calculation.rates'
  | 'tools.ratesGovernmentRent.calculation.reductions'
  | 'tools.ratesGovernmentRent.calculator'
  | 'tools.ratesGovernmentRent.disclaimer'
  | 'tools.ratesGovernmentRent.exemptions'
  | 'tools.ratesGovernmentRent.fields'
  | 'tools.ratesGovernmentRent.howToUse'
  | 'tools.ratesGovernmentRent.result'
  | 'tools.ratesGovernmentRent.schedule'
  | 'tools.ratesGovernmentRent.schedule.rows'
  | 'tools.ratesGovernmentRent.schedule.rows.q1'
  | 'tools.ratesGovernmentRent.schedule.rows.q2'
  | 'tools.ratesGovernmentRent.schedule.rows.q3'
  | 'tools.ratesGovernmentRent.schedule.rows.q4'
  | 'tools.ratesGovernmentRent.seo'
  | 'tools.ratesGovernmentRent.whyUse'
  | 'tools.rentalYield'
  | 'tools.rentalYield.calculator'
  | 'tools.rentalYield.conclusion'
  | 'tools.rentalYield.disclaimer'
  | 'tools.rentalYield.fields'
  | 'tools.rentalYield.howToChoose'
  | 'tools.rentalYield.howToChooseHighReturn'
  | 'tools.rentalYield.howToUse'
  | 'tools.rentalYield.seo'
  | 'tools.stampDuty'
  | 'tools.stampDuty.advantages'
  | 'tools.stampDuty.advantages.points'
  | 'tools.stampDuty.calculator'
  | 'tools.stampDuty.explainer'
  | 'tools.stampDuty.explainer.blocks'
  | 'tools.stampDuty.explainer.blocks.0'
  | 'tools.stampDuty.explainer.blocks.1'
  | 'tools.stampDuty.explainer.blocks.2'
  | 'tools.stampDuty.explainer.blocks.3'
  | 'tools.stampDuty.explainer.blocks.4'
  | 'tools.stampDuty.explainer.blocks.5'
  | 'tools.stampDuty.faqs'
  | 'tools.stampDuty.faqs.list'
  | 'tools.stampDuty.faqs.list.0'
  | 'tools.stampDuty.faqs.list.1'
  | 'tools.stampDuty.faqs.list.2'
  | 'tools.stampDuty.faqs.list.3'
  | 'tools.stampDuty.faqs.list.4'
  | 'tools.stampDuty.faqs.list.5'
  | 'tools.stampDuty.faqs.list.6'
  | 'tools.stampDuty.faqs.list.7'
  | 'tools.stampDuty.howToUse'
  | 'tools.stampDuty.howToUse.steps'
  | 'tools.stampDuty.rates'
  | 'tools.stampDuty.related'
  | 'tools.stampDuty.seo'
  | 'transactions'
  | 'wizard'
  | 'wizard.address'
  | 'wizard.address.floor'
  | 'wizard.address.floorLevel'
  | 'wizard.address.search'
  | 'wizard.address.unit'
  | 'wizard.amenities'
  | 'wizard.description'
  | 'wizard.errors'
  | 'wizard.footer'
  | 'wizard.media'
  | 'wizard.media.dropzone'
  | 'wizard.media.rejected'
  | 'wizard.payment'
  | 'wizard.pricing'
  | 'wizard.size'
  | 'wizard.size.pets'
  | 'wizard.size.propertyType'
  | 'wizard.size.propertyType.options'
  | 'wizard.toast';

/**
 * Namespace → its valid relative keys. A flat interface (not a nested
 * conditional) so `MessageKeys<N>` resolves in O(1) instantiation depth —
 * the deep-conditional form blew the TS recursion limit once combined with
 * the per-key `MessageArgs` template lookup.
 */
// prettier-ignore
export interface MessageKeysByNamespace {
  'about': 'contact.address' | 'contact.hoursTitle' | 'contact.title' | 'contact.weekdays' | 'contact.weekend' | 'description' | 'imageGrid.photoAlt.couple' | 'imageGrid.photoAlt.drawing' | 'imageGrid.photoAlt.hotpot' | 'imageGrid.photoAlt.mahjong' | 'imageGrid.photoAlt.takeaway' | 'imageGrid.photoAlt.team' | 'imageGrid.quote' | 'imageGrid.tagline' | 'seo.description' | 'seo.title' | 'team.bios.christal' | 'team.bios.xavier' | 'team.companyName' | 'team.roles.cofounder' | 'team.subtitle' | 'team.title' | 'title';
  'about.contact': 'address' | 'hoursTitle' | 'title' | 'weekdays' | 'weekend';
  'about.imageGrid': 'photoAlt.couple' | 'photoAlt.drawing' | 'photoAlt.hotpot' | 'photoAlt.mahjong' | 'photoAlt.takeaway' | 'photoAlt.team' | 'quote' | 'tagline';
  'about.imageGrid.photoAlt': 'couple' | 'drawing' | 'hotpot' | 'mahjong' | 'takeaway' | 'team';
  'about.seo': 'description' | 'title';
  'about.team': 'bios.christal' | 'bios.xavier' | 'companyName' | 'roles.cofounder' | 'subtitle' | 'title';
  'about.team.bios': 'christal' | 'xavier';
  'about.team.roles': 'cofounder';
  'auth': 'google.button' | 'google.errorBlocked' | 'google.errorCancelled' | 'google.errorPopupBlocked' | 'google.errorSignIn' | 'modal.or' | 'modal.subtitle' | 'modal.title' | 'otp.back' | 'otp.codeLabel' | 'otp.codePlaceholder' | 'otp.codeSentTo' | 'otp.errorSend' | 'otp.errorVerify' | 'otp.phoneLabel' | 'otp.phonePlaceholder' | 'otp.privacyLink' | 'otp.resend' | 'otp.sendCode' | 'otp.termsAnd' | 'otp.termsLink' | 'otp.termsText' | 'otp.verify' | 'shared.continueWithProvider';
  'auth.google': 'button' | 'errorBlocked' | 'errorCancelled' | 'errorPopupBlocked' | 'errorSignIn';
  'auth.modal': 'or' | 'subtitle' | 'title';
  'auth.otp': 'back' | 'codeLabel' | 'codePlaceholder' | 'codeSentTo' | 'errorSend' | 'errorVerify' | 'phoneLabel' | 'phonePlaceholder' | 'privacyLink' | 'resend' | 'sendCode' | 'termsAnd' | 'termsLink' | 'termsText' | 'verify';
  'auth.shared': 'continueWithProvider';
  'blog': 'allCategories' | 'byAuthor' | 'categoriesLabel' | 'categoryChip' | 'clearSearch' | 'listenToArticle' | 'noPosts' | 'noPostsForSearch' | 'partnerRoleFallback' | 'preview.description' | 'preview.title' | 'relatedPosts' | 'searchLabel' | 'searchPlaceholder' | 'searchSubmit' | 'tableOfContents' | 'title';
  'blog.preview': 'description' | 'title';
  'common': 'a11y.backToHome' | 'a11y.breadcrumb' | 'a11y.carousel' | 'a11y.close' | 'a11y.listingSections' | 'a11y.mobileNavigation' | 'a11y.mute' | 'a11y.nextImage' | 'a11y.nextSlide' | 'a11y.officeLocation' | 'a11y.pause' | 'a11y.play' | 'a11y.previousImage' | 'a11y.previousSlide' | 'a11y.primaryNavigation' | 'a11y.seek' | 'a11y.selectCountry' | 'a11y.slide' | 'a11y.tableOfContents' | 'a11y.unmute' | 'a11y.viewAllImages' | 'a11y.wizardProgress' | 'loading' | 'retry';
  'common.a11y': 'backToHome' | 'breadcrumb' | 'carousel' | 'close' | 'listingSections' | 'mobileNavigation' | 'mute' | 'nextImage' | 'nextSlide' | 'officeLocation' | 'pause' | 'play' | 'previousImage' | 'previousSlide' | 'primaryNavigation' | 'seek' | 'selectCountry' | 'slide' | 'tableOfContents' | 'unmute' | 'viewAllImages' | 'wizardProgress';
  'contact': 'blurb' | 'channel.body' | 'channel.thread' | 'channel.title' | 'elsewhere.body' | 'elsewhere.feedbackLink' | 'elsewhere.helpLink' | 'elsewhere.title' | 'include.device' | 'include.expected' | 'include.intro' | 'include.listing' | 'include.title' | 'include.when' | 'logInAndChat' | 'loginToContact' | 'privacyHint' | 'seo.description' | 'seo.title' | 'title' | 'topics.account' | 'topics.billing' | 'topics.complaint' | 'topics.general' | 'topics.inquiry' | 'topics.intro' | 'topics.listing' | 'topics.other' | 'topics.technical' | 'topics.title' | 'typicalResponse';
  'contact.channel': 'body' | 'thread' | 'title';
  'contact.elsewhere': 'body' | 'feedbackLink' | 'helpLink' | 'title';
  'contact.include': 'device' | 'expected' | 'intro' | 'listing' | 'title' | 'when';
  'contact.seo': 'description' | 'title';
  'contact.topics': 'account' | 'billing' | 'complaint' | 'general' | 'inquiry' | 'intro' | 'listing' | 'other' | 'technical' | 'title';
  'conversations': 'composer.placeholder' | 'dayLabel.today' | 'dayLabel.yesterday' | 'empty.description' | 'empty.title' | 'message.showOriginal' | 'message.showTranslation' | 'message.translated' | 'preview_new_inquiry' | 'supportTitle' | 'systemEvent.awaitingSignature' | 'systemEvent.published' | 'systemEvent.relisted' | 'systemEvent.supportAutoClosed' | 'systemEvent.supportSeedPrompt' | 'systemEvent.unlisted' | 'title' | 'unknownParticipant' | 'you';
  'conversations.composer': 'placeholder';
  'conversations.dayLabel': 'today' | 'yesterday';
  'conversations.empty': 'description' | 'title';
  'conversations.message': 'showOriginal' | 'showTranslation' | 'translated';
  'conversations.systemEvent': 'awaitingSignature' | 'published' | 'relisted' | 'supportAutoClosed' | 'supportSeedPrompt' | 'unlisted';
  'error': 'auth.alreadyLinked' | 'auth.codeRequired' | 'auth.emailInUse' | 'auth.emailNotVerified' | 'auth.googleSignInFailed' | 'auth.invalidCode' | 'auth.invalidInput' | 'auth.invalidPhone' | 'auth.invalidToken' | 'auth.lastProvider' | 'auth.notLinked' | 'auth.phoneInUse' | 'auth.phoneNumberRequired' | 'auth.rateLimited' | 'conversations.contentEmpty' | 'conversations.conversationIdRequired' | 'conversations.invalidInput' | 'conversations.messageBlockedExternalContact' | 'conversations.notParticipant' | 'conversations.unknownReadCursor' | 'feedbacks.emptyMessage' | 'generic' | 'leads.alreadyExists' | 'leads.invalidInput' | 'leads.listingNotLive' | 'leads.notFound' | 'leads.selfInquiry' | 'listings.alreadyExists' | 'listings.buildingNotFound' | 'listings.cannotPublishNonInProg' | 'listings.cannotRelistIncomplete' | 'listings.cannotRelistNonUnlisted' | 'listings.cannotUnlistNonListed' | 'listings.imageIdRequired' | 'listings.imageNotFound' | 'listings.invalidInput' | 'listings.listingNotFound' | 'listings.notOwner' | 'listings.wizardIncomplete' | 'payments.alreadyPaid' | 'payments.checkoutDisabled' | 'saved.alreadyExists' | 'saved.invalidInput' | 'saved.invalidSaveableId' | 'saved.notFound' | 'storefront.categoryNotFound' | 'storefront.districtNotFound' | 'storefront.estateNotFound' | 'storefront.listingNotFound' | 'storefront.partnerNotFound' | 'storefront.postNotFound' | 'support.invalidInput' | 'support.notFound';
  'error.auth': 'alreadyLinked' | 'codeRequired' | 'emailInUse' | 'emailNotVerified' | 'googleSignInFailed' | 'invalidCode' | 'invalidInput' | 'invalidPhone' | 'invalidToken' | 'lastProvider' | 'notLinked' | 'phoneInUse' | 'phoneNumberRequired' | 'rateLimited';
  'error.conversations': 'contentEmpty' | 'conversationIdRequired' | 'invalidInput' | 'messageBlockedExternalContact' | 'notParticipant' | 'unknownReadCursor';
  'error.feedbacks': 'emptyMessage';
  'error.leads': 'alreadyExists' | 'invalidInput' | 'listingNotLive' | 'notFound' | 'selfInquiry';
  'error.listings': 'alreadyExists' | 'buildingNotFound' | 'cannotPublishNonInProg' | 'cannotRelistIncomplete' | 'cannotRelistNonUnlisted' | 'cannotUnlistNonListed' | 'imageIdRequired' | 'imageNotFound' | 'invalidInput' | 'listingNotFound' | 'notOwner' | 'wizardIncomplete';
  'error.payments': 'alreadyPaid' | 'checkoutDisabled';
  'error.saved': 'alreadyExists' | 'invalidInput' | 'invalidSaveableId' | 'notFound';
  'error.storefront': 'categoryNotFound' | 'districtNotFound' | 'estateNotFound' | 'listingNotFound' | 'partnerNotFound' | 'postNotFound';
  'error.support': 'invalidInput' | 'notFound';
  'estates': 'card.blocks' | 'card.forRent' | 'card.forSale' | 'clearSearch' | 'detail.buildings.forRent' | 'detail.buildings.forSale' | 'detail.buildingsCount' | 'detail.census.attribution.dataGovHk' | 'detail.census.attribution.terms' | 'detail.census.dataSource' | 'detail.census.female' | 'detail.census.genderHeading' | 'detail.census.heading' | 'detail.census.male' | 'detail.census.table.gender' | 'detail.census.table.percentage' | 'detail.census.table.population' | 'detail.ctaButton' | 'detail.ctaTitle' | 'detail.facts.blocks' | 'detail.facts.lift' | 'detail.facts.no' | 'detail.facts.phase' | 'detail.facts.poi.carPark' | 'detail.facts.poi.hospital' | 'detail.facts.poi.mtr' | 'detail.facts.poi.school' | 'detail.facts.poi.value' | 'detail.facts.title' | 'detail.facts.type' | 'detail.facts.village' | 'detail.facts.yes' | 'detail.faqs.title' | 'detail.gallery.viewAll' | 'detail.listingCount' | 'detail.location' | 'detail.nearMtr' | 'detail.nearbyRentListings' | 'detail.nearbySaleListings' | 'detail.phases' | 'detail.photoAlt' | 'detail.priceTrend.disclaimer' | 'detail.priceTrend.month' | 'detail.priceTrend.rent' | 'detail.priceTrend.sale' | 'detail.priceTrend.samples' | 'detail.priceTrend.title' | 'detail.rentListings' | 'detail.saleListings' | 'detail.similar' | 'districtFacet.about.buy' | 'districtFacet.about.rent' | 'districtFacet.aboutEmpty.buy' | 'districtFacet.aboutEmpty.rent' | 'districtFacet.aboutHeading' | 'districtFacet.backToHub' | 'districtFacet.buyLink' | 'districtFacet.guidance.buy' | 'districtFacet.guidance.rent' | 'districtFacet.nearbyBuy' | 'districtFacet.nearbyRent' | 'districtFacet.population' | 'districtFacet.rentLink' | 'noEstates' | 'noneForSearch' | 'searchLabel' | 'searchPlaceholder' | 'searchSubmit' | 'showing' | 'subtitle' | 'title';
  'estates.card': 'blocks' | 'forRent' | 'forSale';
  'estates.detail': 'buildings.forRent' | 'buildings.forSale' | 'buildingsCount' | 'census.attribution.dataGovHk' | 'census.attribution.terms' | 'census.dataSource' | 'census.female' | 'census.genderHeading' | 'census.heading' | 'census.male' | 'census.table.gender' | 'census.table.percentage' | 'census.table.population' | 'ctaButton' | 'ctaTitle' | 'facts.blocks' | 'facts.lift' | 'facts.no' | 'facts.phase' | 'facts.poi.carPark' | 'facts.poi.hospital' | 'facts.poi.mtr' | 'facts.poi.school' | 'facts.poi.value' | 'facts.title' | 'facts.type' | 'facts.village' | 'facts.yes' | 'faqs.title' | 'gallery.viewAll' | 'listingCount' | 'location' | 'nearMtr' | 'nearbyRentListings' | 'nearbySaleListings' | 'phases' | 'photoAlt' | 'priceTrend.disclaimer' | 'priceTrend.month' | 'priceTrend.rent' | 'priceTrend.sale' | 'priceTrend.samples' | 'priceTrend.title' | 'rentListings' | 'saleListings' | 'similar';
  'estates.detail.buildings': 'forRent' | 'forSale';
  'estates.detail.census': 'attribution.dataGovHk' | 'attribution.terms' | 'dataSource' | 'female' | 'genderHeading' | 'heading' | 'male' | 'table.gender' | 'table.percentage' | 'table.population';
  'estates.detail.census.attribution': 'dataGovHk' | 'terms';
  'estates.detail.census.table': 'gender' | 'percentage' | 'population';
  'estates.detail.facts': 'blocks' | 'lift' | 'no' | 'phase' | 'poi.carPark' | 'poi.hospital' | 'poi.mtr' | 'poi.school' | 'poi.value' | 'title' | 'type' | 'village' | 'yes';
  'estates.detail.facts.poi': 'carPark' | 'hospital' | 'mtr' | 'school' | 'value';
  'estates.detail.faqs': 'title';
  'estates.detail.gallery': 'viewAll';
  'estates.detail.priceTrend': 'disclaimer' | 'month' | 'rent' | 'sale' | 'samples' | 'title';
  'estates.districtFacet': 'about.buy' | 'about.rent' | 'aboutEmpty.buy' | 'aboutEmpty.rent' | 'aboutHeading' | 'backToHub' | 'buyLink' | 'guidance.buy' | 'guidance.rent' | 'nearbyBuy' | 'nearbyRent' | 'population' | 'rentLink';
  'estates.districtFacet.about': 'buy' | 'rent';
  'estates.districtFacet.aboutEmpty': 'buy' | 'rent';
  'estates.districtFacet.guidance': 'buy' | 'rent';
  'feedback': 'backToHome' | 'contactSupport' | 'instead.body' | 'instead.title' | 'intro' | 'messageLabel' | 'messagePlaceholder' | 'needHelp' | 'seo.description' | 'seo.title' | 'signedIn' | 'submit' | 'submitError' | 'submitting' | 'thankYouMessage' | 'thankYouTitle' | 'title' | 'useful.broken' | 'useful.confusing' | 'useful.missing' | 'useful.title' | 'useful.working' | 'whatHappens.body' | 'whatHappens.title';
  'feedback.instead': 'body' | 'title';
  'feedback.seo': 'description' | 'title';
  'feedback.useful': 'broken' | 'confusing' | 'missing' | 'title' | 'working';
  'feedback.whatHappens': 'body' | 'title';
  'forms': 'disclaimer.paragraphs.0' | 'disclaimer.paragraphs.1' | 'disclaimer.paragraphs.2' | 'disclaimer.title' | 'documents.carParkLeaseAgreement.description' | 'documents.carParkLeaseAgreement.file' | 'documents.carParkLeaseAgreement.label' | 'documents.completeRentalChecklist.description' | 'documents.completeRentalChecklist.file' | 'documents.completeRentalChecklist.label' | 'documents.incomeProofSalaried.description' | 'documents.incomeProofSalaried.file' | 'documents.incomeProofSalaried.label' | 'documents.incomeProofSelfEmployed.description' | 'documents.incomeProofSelfEmployed.file' | 'documents.incomeProofSelfEmployed.label' | 'documents.provisionalTenancyAgreement.description' | 'documents.provisionalTenancyAgreement.file' | 'documents.provisionalTenancyAgreement.label' | 'documents.surrenderAgreement.description' | 'documents.surrenderAgreement.file' | 'documents.surrenderAgreement.label' | 'heading' | 'seo.description' | 'seo.title' | 'title';
  'forms.disclaimer': 'paragraphs.0' | 'paragraphs.1' | 'paragraphs.2' | 'title';
  'forms.disclaimer.paragraphs': '0' | '1' | '2';
  'forms.documents': 'carParkLeaseAgreement.description' | 'carParkLeaseAgreement.file' | 'carParkLeaseAgreement.label' | 'completeRentalChecklist.description' | 'completeRentalChecklist.file' | 'completeRentalChecklist.label' | 'incomeProofSalaried.description' | 'incomeProofSalaried.file' | 'incomeProofSalaried.label' | 'incomeProofSelfEmployed.description' | 'incomeProofSelfEmployed.file' | 'incomeProofSelfEmployed.label' | 'provisionalTenancyAgreement.description' | 'provisionalTenancyAgreement.file' | 'provisionalTenancyAgreement.label' | 'surrenderAgreement.description' | 'surrenderAgreement.file' | 'surrenderAgreement.label';
  'forms.documents.carParkLeaseAgreement': 'description' | 'file' | 'label';
  'forms.documents.completeRentalChecklist': 'description' | 'file' | 'label';
  'forms.documents.incomeProofSalaried': 'description' | 'file' | 'label';
  'forms.documents.incomeProofSelfEmployed': 'description' | 'file' | 'label';
  'forms.documents.provisionalTenancyAgreement': 'description' | 'file' | 'label';
  'forms.documents.surrenderAgreement': 'description' | 'file' | 'label';
  'forms.seo': 'description' | 'title';
  'help': 'contactFeedback.contact.body' | 'contactFeedback.contact.button' | 'contactFeedback.contact.title' | 'contactFeedback.feedback.body' | 'contactFeedback.feedback.button' | 'contactFeedback.feedback.title' | 'greeting' | 'links.buyVsRent' | 'links.chineseConverter' | 'links.forms' | 'links.ratesGovernmentRent' | 'links.rentalYield' | 'links.schoolsAndRentals' | 'links.services' | 'links.stampDuty' | 'seo.description' | 'seo.title' | 'title';
  'help.contactFeedback': 'contact.body' | 'contact.button' | 'contact.title' | 'feedback.body' | 'feedback.button' | 'feedback.title';
  'help.contactFeedback.contact': 'body' | 'button' | 'title';
  'help.contactFeedback.feedback': 'body' | 'button' | 'title';
  'help.links': 'buyVsRent' | 'chineseConverter' | 'forms' | 'ratesGovernmentRent' | 'rentalYield' | 'schoolsAndRentals' | 'services' | 'stampDuty';
  'help.seo': 'description' | 'title';
  'home': 'faqs.heading' | 'faqs.items.hardSell.answer' | 'faqs.items.hardSell.question' | 'faqs.items.propertyTypes.answer' | 'faqs.items.propertyTypes.question' | 'faqs.items.whatIsLgh.answer' | 'faqs.items.whatIsLgh.question' | 'hero.searchExamples.0' | 'hero.searchExamples.1' | 'hero.searchExamples.2' | 'hero.searchExamples.3' | 'hero.searchExamples.4' | 'hero.title' | 'tips.title' | 'whyUs.cta' | 'whyUs.heading' | 'whyUs.serveNotSell.description' | 'whyUs.serveNotSell.heading' | 'whyUs.valueForMoney.description' | 'whyUs.valueForMoney.heading' | 'whyUs.videoAlt';
  'home.faqs': 'heading' | 'items.hardSell.answer' | 'items.hardSell.question' | 'items.propertyTypes.answer' | 'items.propertyTypes.question' | 'items.whatIsLgh.answer' | 'items.whatIsLgh.question';
  'home.faqs.items': 'hardSell.answer' | 'hardSell.question' | 'propertyTypes.answer' | 'propertyTypes.question' | 'whatIsLgh.answer' | 'whatIsLgh.question';
  'home.faqs.items.hardSell': 'answer' | 'question';
  'home.faqs.items.propertyTypes': 'answer' | 'question';
  'home.faqs.items.whatIsLgh': 'answer' | 'question';
  'home.hero': 'searchExamples.0' | 'searchExamples.1' | 'searchExamples.2' | 'searchExamples.3' | 'searchExamples.4' | 'title';
  'home.hero.searchExamples': '0' | '1' | '2' | '3' | '4';
  'home.tips': 'title';
  'home.whyUs': 'cta' | 'heading' | 'serveNotSell.description' | 'serveNotSell.heading' | 'valueForMoney.description' | 'valueForMoney.heading' | 'videoAlt';
  'home.whyUs.serveNotSell': 'description' | 'heading';
  'home.whyUs.valueForMoney': 'description' | 'heading';
  'inquiry': 'budgetPlaceholder' | 'errors.failed' | 'errors.messageRequired' | 'intentBuy' | 'intentLabel' | 'intentRent' | 'leaseTerm' | 'leaseTermPlaceholder' | 'maxBudget' | 'messageLabel' | 'messagePlaceholder' | 'moveInDate' | 'occupantsCount' | 'occupantsPlaceholder' | 'perMonth' | 'purchaseTimeframe' | 'sending' | 'submit' | 'success' | 'timeframeHint' | 'timeframePlaceholder' | 'title';
  'inquiry.errors': 'failed' | 'messageRequired';
  'legal': 'privacyPolicy.afterDeletion' | 'privacyPolicy.afterDeletionTitle' | 'privacyPolicy.changesToPolicy' | 'privacyPolicy.changesToPolicyTitle' | 'privacyPolicy.contactUs' | 'privacyPolicy.contactUsTitle' | 'privacyPolicy.cookiePolicyTitle' | 'privacyPolicy.exceptions' | 'privacyPolicy.exceptionsTitle' | 'privacyPolicy.howWeShare' | 'privacyPolicy.howWeShareTitle' | 'privacyPolicy.howWeUse' | 'privacyPolicy.howWeUseTitle' | 'privacyPolicy.informationWeCollect' | 'privacyPolicy.informationWeCollectTitle' | 'privacyPolicy.introduction' | 'privacyPolicy.introductionTitle' | 'privacyPolicy.lastUpdated' | 'privacyPolicy.personalInformation.description' | 'privacyPolicy.personalInformation.label' | 'privacyPolicy.propertyInformation.description' | 'privacyPolicy.propertyInformation.label' | 'privacyPolicy.security' | 'privacyPolicy.securityTitle' | 'privacyPolicy.seo.description' | 'privacyPolicy.seo.title' | 'privacyPolicy.siteProtection.label' | 'privacyPolicy.title' | 'privacyPolicy.usages.facilitateTransactions' | 'privacyPolicy.usages.improveWebsite' | 'privacyPolicy.usages.respondToInquiries' | 'privacyPolicy.yourRights' | 'privacyPolicy.yourRightsTitle' | 'termsOfService.accountRegistration' | 'termsOfService.accountRegistrationTitle' | 'termsOfService.changesToTerms' | 'termsOfService.changesToTermsTitle' | 'termsOfService.contactUs' | 'termsOfService.contactUsTitle' | 'termsOfService.content' | 'termsOfService.contentTitle' | 'termsOfService.disclaimer' | 'termsOfService.disclaimerTitle' | 'termsOfService.eligibility' | 'termsOfService.eligibilityTitle' | 'termsOfService.governingLaw' | 'termsOfService.governingLawTitle' | 'termsOfService.introduction' | 'termsOfService.introductionTitle' | 'termsOfService.lastUpdated' | 'termsOfService.limitationOfLiability' | 'termsOfService.limitationOfLiabilityTitle' | 'termsOfService.seo.description' | 'termsOfService.seo.title' | 'termsOfService.title' | 'termsOfService.userObligations' | 'termsOfService.userObligationsTitle';
  'legal.privacyPolicy': 'afterDeletion' | 'afterDeletionTitle' | 'changesToPolicy' | 'changesToPolicyTitle' | 'contactUs' | 'contactUsTitle' | 'cookiePolicyTitle' | 'exceptions' | 'exceptionsTitle' | 'howWeShare' | 'howWeShareTitle' | 'howWeUse' | 'howWeUseTitle' | 'informationWeCollect' | 'informationWeCollectTitle' | 'introduction' | 'introductionTitle' | 'lastUpdated' | 'personalInformation.description' | 'personalInformation.label' | 'propertyInformation.description' | 'propertyInformation.label' | 'security' | 'securityTitle' | 'seo.description' | 'seo.title' | 'siteProtection.label' | 'title' | 'usages.facilitateTransactions' | 'usages.improveWebsite' | 'usages.respondToInquiries' | 'yourRights' | 'yourRightsTitle';
  'legal.privacyPolicy.personalInformation': 'description' | 'label';
  'legal.privacyPolicy.propertyInformation': 'description' | 'label';
  'legal.privacyPolicy.seo': 'description' | 'title';
  'legal.privacyPolicy.siteProtection': 'label';
  'legal.privacyPolicy.usages': 'facilitateTransactions' | 'improveWebsite' | 'respondToInquiries';
  'legal.termsOfService': 'accountRegistration' | 'accountRegistrationTitle' | 'changesToTerms' | 'changesToTermsTitle' | 'contactUs' | 'contactUsTitle' | 'content' | 'contentTitle' | 'disclaimer' | 'disclaimerTitle' | 'eligibility' | 'eligibilityTitle' | 'governingLaw' | 'governingLawTitle' | 'introduction' | 'introductionTitle' | 'lastUpdated' | 'limitationOfLiability' | 'limitationOfLiabilityTitle' | 'seo.description' | 'seo.title' | 'title' | 'userObligations' | 'userObligationsTitle';
  'legal.termsOfService.seo': 'description' | 'title';
  'listings': 'browse.failedToLoad' | 'browse.failedToLoadShort' | 'browse.map' | 'browse.noListings' | 'browse.noListingsShort' | 'browse.propertyCount' | 'browse.propertyListings' | 'card.bathrooms' | 'card.bedrooms' | 'card.bedroomsStudio' | 'card.noImage' | 'card.perMonth' | 'card.save' | 'card.saved' | 'card.sqft' | 'card.statusAwaitingSignature' | 'card.statusDeleted' | 'card.statusInProgress' | 'card.statusListed' | 'card.statusPublishing' | 'card.statusUnlisted' | 'carousel.forRent' | 'carousel.forSale' | 'dashboard.createButton' | 'dashboard.empty.cta' | 'dashboard.empty.description' | 'dashboard.empty.title' | 'dashboard.title' | 'detail.about.title' | 'detail.amenities' | 'detail.bathrooms' | 'detail.bathroomsLabel' | 'detail.bedrooms' | 'detail.bedroomsLabel' | 'detail.continueConversation' | 'detail.description' | 'detail.floorLabel' | 'detail.forRent' | 'detail.forSale' | 'detail.interestedSubtitle' | 'detail.interestedTitle' | 'detail.listerSubtitle' | 'detail.location' | 'detail.manageListing' | 'detail.messageLister' | 'detail.notAvailable' | 'detail.originalNotice' | 'detail.perMonth' | 'detail.petsAllowed' | 'detail.petsLabel' | 'detail.petsNotAllowed' | 'detail.propertyInfo' | 'detail.ref' | 'detail.showOriginal' | 'detail.showTranslation' | 'detail.sizeLabel' | 'detail.sqft' | 'detail.studio' | 'detail.translatedNotice' | 'detail.unknownLocation' | 'editor.actions.view' | 'editor.morePhotos' | 'editor.noPhotos' | 'editor.sections.address' | 'editor.sections.amenities' | 'editor.sections.description' | 'editor.sections.media' | 'editor.sections.pricing' | 'editor.sections.size' | 'editor.title' | 'editor.untitled' | 'filters.any' | 'filters.apply' | 'filters.bathrooms' | 'filters.bedrooms' | 'filters.buttonLabel' | 'filters.buttonLabelWithCount' | 'filters.petsAllowed' | 'filters.priceRange' | 'filters.reset' | 'filters.rooms' | 'filters.showResults' | 'filters.title' | 'gallery.morePhotos' | 'gallery.noImages' | 'gallery.title' | 'gallery.viewAll' | 'new.cta' | 'new.ctaSubtext' | 'new.steps.0.subtitle' | 'new.steps.0.title' | 'new.steps.1.subtitle' | 'new.steps.1.title' | 'new.steps.2.subtitle' | 'new.steps.2.title' | 'new.title' | 'searchClose' | 'searchLocation' | 'sort.label' | 'sort.newest' | 'sort.priceAsc' | 'sort.priceDesc' | 'typeFacet.backToBuy' | 'typeFacet.backToRent';
  'listings.browse': 'failedToLoad' | 'failedToLoadShort' | 'map' | 'noListings' | 'noListingsShort' | 'propertyCount' | 'propertyListings';
  'listings.card': 'bathrooms' | 'bedrooms' | 'bedroomsStudio' | 'noImage' | 'perMonth' | 'save' | 'saved' | 'sqft' | 'statusAwaitingSignature' | 'statusDeleted' | 'statusInProgress' | 'statusListed' | 'statusPublishing' | 'statusUnlisted';
  'listings.carousel': 'forRent' | 'forSale';
  'listings.dashboard': 'createButton' | 'empty.cta' | 'empty.description' | 'empty.title' | 'title';
  'listings.dashboard.empty': 'cta' | 'description' | 'title';
  'listings.detail': 'about.title' | 'amenities' | 'bathrooms' | 'bathroomsLabel' | 'bedrooms' | 'bedroomsLabel' | 'continueConversation' | 'description' | 'floorLabel' | 'forRent' | 'forSale' | 'interestedSubtitle' | 'interestedTitle' | 'listerSubtitle' | 'location' | 'manageListing' | 'messageLister' | 'notAvailable' | 'originalNotice' | 'perMonth' | 'petsAllowed' | 'petsLabel' | 'petsNotAllowed' | 'propertyInfo' | 'ref' | 'showOriginal' | 'showTranslation' | 'sizeLabel' | 'sqft' | 'studio' | 'translatedNotice' | 'unknownLocation';
  'listings.detail.about': 'title';
  'listings.editor': 'actions.view' | 'morePhotos' | 'noPhotos' | 'sections.address' | 'sections.amenities' | 'sections.description' | 'sections.media' | 'sections.pricing' | 'sections.size' | 'title' | 'untitled';
  'listings.editor.actions': 'view';
  'listings.editor.sections': 'address' | 'amenities' | 'description' | 'media' | 'pricing' | 'size';
  'listings.filters': 'any' | 'apply' | 'bathrooms' | 'bedrooms' | 'buttonLabel' | 'buttonLabelWithCount' | 'petsAllowed' | 'priceRange' | 'reset' | 'rooms' | 'showResults' | 'title';
  'listings.gallery': 'morePhotos' | 'noImages' | 'title' | 'viewAll';
  'listings.new': 'cta' | 'ctaSubtext' | 'steps.0.subtitle' | 'steps.0.title' | 'steps.1.subtitle' | 'steps.1.title' | 'steps.2.subtitle' | 'steps.2.title' | 'title';
  'listings.new.steps': '0.subtitle' | '0.title' | '1.subtitle' | '1.title' | '2.subtitle' | '2.title';
  'listings.new.steps.0': 'subtitle' | 'title';
  'listings.new.steps.1': 'subtitle' | 'title';
  'listings.new.steps.2': 'subtitle' | 'title';
  'listings.sort': 'label' | 'newest' | 'priceAsc' | 'priceDesc';
  'listings.typeFacet': 'backToBuy' | 'backToRent';
  'market': 'attribution.heading' | 'attribution.terms' | 'empty' | 'month' | 'provisionalHint' | 'provisionalMark' | 'sourceLine' | 'subtitle';
  'market.attribution': 'heading' | 'terms';
  'messages': 'signed.out.help' | 'signed.out.intro';
  'messages.signed': 'out.help' | 'out.intro';
  'messages.signed.out': 'help' | 'intro';
  'nav': 'account.dashboard' | 'account.helpCenter' | 'account.listProperty' | 'account.listings' | 'account.loginOrSignUp' | 'account.messages' | 'account.saved' | 'account.settings' | 'account.signOut' | 'buy' | 'explore' | 'footer.companyName' | 'footer.groups.company' | 'footer.groups.explore' | 'footer.groups.support' | 'footer.legal.privacy' | 'footer.legal.terms' | 'footer.links.aboutUs' | 'footer.links.blog' | 'footer.links.buyProperty' | 'footer.links.contactSupport' | 'footer.links.districts' | 'footer.links.estates' | 'footer.links.giveFeedback' | 'footer.links.helpCenter' | 'footer.links.market' | 'footer.links.partners' | 'footer.links.rentProperty' | 'footer.links.services' | 'footer.links.tools' | 'footer.links.transactions' | 'footer.visitOn' | 'language' | 'messages' | 'profile' | 'rent' | 'saved';
  'nav.account': 'dashboard' | 'helpCenter' | 'listProperty' | 'listings' | 'loginOrSignUp' | 'messages' | 'saved' | 'settings' | 'signOut';
  'nav.footer': 'companyName' | 'groups.company' | 'groups.explore' | 'groups.support' | 'legal.privacy' | 'legal.terms' | 'links.aboutUs' | 'links.blog' | 'links.buyProperty' | 'links.contactSupport' | 'links.districts' | 'links.estates' | 'links.giveFeedback' | 'links.helpCenter' | 'links.market' | 'links.partners' | 'links.rentProperty' | 'links.services' | 'links.tools' | 'links.transactions' | 'visitOn';
  'nav.footer.groups': 'company' | 'explore' | 'support';
  'nav.footer.legal': 'privacy' | 'terms';
  'nav.footer.links': 'aboutUs' | 'blog' | 'buyProperty' | 'contactSupport' | 'districts' | 'estates' | 'giveFeedback' | 'helpCenter' | 'market' | 'partners' | 'rentProperty' | 'services' | 'tools' | 'transactions';
  'pageTitles': 'address' | 'amenities' | 'conversation' | 'description' | 'inquiry' | 'listingEditor' | 'messages' | 'myListings' | 'newListing' | 'payment' | 'photos' | 'postPreview' | 'pricing' | 'profile' | 'saved' | 'settings' | 'sizeLayout';
  'pager': 'gotoPage' | 'label' | 'next' | 'pageOf' | 'previous';
  'partners': 'about.body' | 'about.title' | 'directory.count' | 'directory.how.body' | 'directory.how.title' | 'directory.roles' | 'howToJoin.body' | 'howToJoin.cta' | 'howToJoin.title' | 'noPartners' | 'noPostsYet' | 'postsByPartner' | 'readGuides.body' | 'readGuides.cta' | 'readGuides.title' | 'subtitle' | 'title' | 'visitWebsite';
  'partners.about': 'body' | 'title';
  'partners.directory': 'count' | 'how.body' | 'how.title' | 'roles';
  'partners.directory.how': 'body' | 'title';
  'partners.howToJoin': 'body' | 'cta' | 'title';
  'partners.readGuides': 'body' | 'cta' | 'title';
  'pets': 'policy.allowed' | 'policy.not_allowed';
  'pets.policy': 'allowed' | 'not_allowed';
  'preferences': 'autoTranslate.description' | 'autoTranslate.label' | 'currency.label' | 'currency.options.cny' | 'currency.options.hkd' | 'language.label' | 'title' | 'unitSystem.label' | 'unitSystem.options.imperial' | 'unitSystem.options.metric';
  'preferences.autoTranslate': 'description' | 'label';
  'preferences.currency': 'label' | 'options.cny' | 'options.hkd';
  'preferences.currency.options': 'cny' | 'hkd';
  'preferences.language': 'label';
  'preferences.unitSystem': 'label' | 'options.imperial' | 'options.metric';
  'preferences.unitSystem.options': 'imperial' | 'metric';
  'profile': 'list.property.description' | 'list.property.title' | 'signed.out.intro' | 'title';
  'profile.list': 'property.description' | 'property.title';
  'profile.list.property': 'description' | 'title';
  'profile.signed': 'out.intro';
  'profile.signed.out': 'intro';
  'saved': 'empty.cta' | 'empty.description' | 'empty.title' | 'signed.out.help' | 'signed.out.intro' | 'subtitle' | 'title' | 'unavailable';
  'saved.empty': 'cta' | 'description' | 'title';
  'saved.signed': 'out.help' | 'out.intro';
  'saved.signed.out': 'help' | 'intro';
  'schoolsAndRentals': 'dataAccuracy.details' | 'dataAccuracy.title' | 'disclaimerSection.details' | 'disclaimerSection.title' | 'faqs.list.0.answer' | 'faqs.list.0.question' | 'faqs.list.1.answer' | 'faqs.list.1.question' | 'faqs.list.2.answer' | 'faqs.list.2.question' | 'faqs.list.3.answer' | 'faqs.list.3.question' | 'faqs.list.4.answer' | 'faqs.list.4.question' | 'faqs.title' | 'pageTitle' | 'peaceOfMind.details' | 'peaceOfMind.title' | 'rentalListings.details' | 'rentalListings.title' | 'seo.description' | 'seo.title' | 'subtitle' | 'title' | 'whyChoose.details.0' | 'whyChoose.details.1' | 'whyChoose.details.2' | 'whyChoose.title';
  'schoolsAndRentals.dataAccuracy': 'details' | 'title';
  'schoolsAndRentals.disclaimerSection': 'details' | 'title';
  'schoolsAndRentals.faqs': 'list.0.answer' | 'list.0.question' | 'list.1.answer' | 'list.1.question' | 'list.2.answer' | 'list.2.question' | 'list.3.answer' | 'list.3.question' | 'list.4.answer' | 'list.4.question' | 'title';
  'schoolsAndRentals.faqs.list': '0.answer' | '0.question' | '1.answer' | '1.question' | '2.answer' | '2.question' | '3.answer' | '3.question' | '4.answer' | '4.question';
  'schoolsAndRentals.faqs.list.0': 'answer' | 'question';
  'schoolsAndRentals.faqs.list.1': 'answer' | 'question';
  'schoolsAndRentals.faqs.list.2': 'answer' | 'question';
  'schoolsAndRentals.faqs.list.3': 'answer' | 'question';
  'schoolsAndRentals.faqs.list.4': 'answer' | 'question';
  'schoolsAndRentals.peaceOfMind': 'details' | 'title';
  'schoolsAndRentals.rentalListings': 'details' | 'title';
  'schoolsAndRentals.seo': 'description' | 'title';
  'schoolsAndRentals.whyChoose': 'details.0' | 'details.1' | 'details.2' | 'title';
  'schoolsAndRentals.whyChoose.details': '0' | '1' | '2';
  'search': 'clear' | 'placeholder' | 'rentCount' | 'saleCount' | 'sections.buildings' | 'sections.districts' | 'sections.estates' | 'submit' | 'suggestions.emptyHint' | 'suggestions.emptyTitle' | 'suggestions.errorHint' | 'suggestions.errorTitle' | 'suggestions.loading';
  'search.sections': 'buildings' | 'districts' | 'estates';
  'search.suggestions': 'emptyHint' | 'emptyTitle' | 'errorHint' | 'errorTitle' | 'loading';
  'services': 'buyRent.assisted.features.0' | 'buyRent.assisted.features.1' | 'buyRent.assisted.features.2' | 'buyRent.assisted.title' | 'buyRent.cta' | 'buyRent.self.features.0' | 'buyRent.self.features.1' | 'buyRent.self.features.2' | 'buyRent.self.title' | 'buyRent.subtitle' | 'buyRent.title' | 'closing' | 'faqs.list.0.answer' | 'faqs.list.0.question' | 'faqs.list.1.answer' | 'faqs.list.1.question' | 'faqs.list.2.answer' | 'faqs.list.2.question' | 'faqs.list.3.answer' | 'faqs.list.3.question' | 'faqs.title' | 'learnMore' | 'scrollToExplore' | 'sellLease.assisted.features.0' | 'sellLease.assisted.features.1' | 'sellLease.assisted.features.2' | 'sellLease.assisted.title' | 'sellLease.cta' | 'sellLease.self.features.0' | 'sellLease.self.features.1' | 'sellLease.self.features.2' | 'sellLease.self.title' | 'sellLease.subtitle' | 'sellLease.title' | 'seo.description' | 'seo.title' | 'socialProof.testimonials.0.name' | 'socialProof.testimonials.0.text' | 'socialProof.testimonials.1.name' | 'socialProof.testimonials.1.text' | 'socialProof.testimonials.2.name' | 'socialProof.testimonials.2.text' | 'socialProof.testimonials.3.name' | 'socialProof.testimonials.3.text' | 'socialProof.testimonials.4.name' | 'socialProof.testimonials.4.text' | 'socialProof.title' | 'subtitle' | 'tabs.assisted' | 'tabs.self' | 'title';
  'services.buyRent': 'assisted.features.0' | 'assisted.features.1' | 'assisted.features.2' | 'assisted.title' | 'cta' | 'self.features.0' | 'self.features.1' | 'self.features.2' | 'self.title' | 'subtitle' | 'title';
  'services.buyRent.assisted': 'features.0' | 'features.1' | 'features.2' | 'title';
  'services.buyRent.assisted.features': '0' | '1' | '2';
  'services.buyRent.self': 'features.0' | 'features.1' | 'features.2' | 'title';
  'services.buyRent.self.features': '0' | '1' | '2';
  'services.faqs': 'list.0.answer' | 'list.0.question' | 'list.1.answer' | 'list.1.question' | 'list.2.answer' | 'list.2.question' | 'list.3.answer' | 'list.3.question' | 'title';
  'services.faqs.list': '0.answer' | '0.question' | '1.answer' | '1.question' | '2.answer' | '2.question' | '3.answer' | '3.question';
  'services.faqs.list.0': 'answer' | 'question';
  'services.faqs.list.1': 'answer' | 'question';
  'services.faqs.list.2': 'answer' | 'question';
  'services.faqs.list.3': 'answer' | 'question';
  'services.sellLease': 'assisted.features.0' | 'assisted.features.1' | 'assisted.features.2' | 'assisted.title' | 'cta' | 'self.features.0' | 'self.features.1' | 'self.features.2' | 'self.title' | 'subtitle' | 'title';
  'services.sellLease.assisted': 'features.0' | 'features.1' | 'features.2' | 'title';
  'services.sellLease.assisted.features': '0' | '1' | '2';
  'services.sellLease.self': 'features.0' | 'features.1' | 'features.2' | 'title';
  'services.sellLease.self.features': '0' | '1' | '2';
  'services.seo': 'description' | 'title';
  'services.socialProof': 'testimonials.0.name' | 'testimonials.0.text' | 'testimonials.1.name' | 'testimonials.1.text' | 'testimonials.2.name' | 'testimonials.2.text' | 'testimonials.3.name' | 'testimonials.3.text' | 'testimonials.4.name' | 'testimonials.4.text' | 'title';
  'services.socialProof.testimonials': '0.name' | '0.text' | '1.name' | '1.text' | '2.name' | '2.text' | '3.name' | '3.text' | '4.name' | '4.text';
  'services.socialProof.testimonials.0': 'name' | 'text';
  'services.socialProof.testimonials.1': 'name' | 'text';
  'services.socialProof.testimonials.2': 'name' | 'text';
  'services.socialProof.testimonials.3': 'name' | 'text';
  'services.socialProof.testimonials.4': 'name' | 'text';
  'services.tabs': 'assisted' | 'self';
  'settings': 'autoTranslate.hint' | 'autoTranslate.label' | 'autoTranslate.title' | 'first_name.label' | 'first_name.placeholder' | 'last_name.label' | 'last_name.placeholder' | 'not_set' | 'notifications.email.subtitle' | 'notifications.email.title' | 'notifications.push.subtitle' | 'notifications.push.title' | 'notifications.sms.subtitle' | 'notifications.sms.title' | 'notifications.title' | 'notifications.whatsapp.subtitle' | 'notifications.whatsapp.title' | 'personal.info' | 'phone.change.hint' | 'phone.number' | 'save' | 'save_error' | 'saved' | 'title';
  'settings.autoTranslate': 'hint' | 'label' | 'title';
  'settings.first_name': 'label' | 'placeholder';
  'settings.last_name': 'label' | 'placeholder';
  'settings.notifications': 'email.subtitle' | 'email.title' | 'push.subtitle' | 'push.title' | 'sms.subtitle' | 'sms.title' | 'title' | 'whatsapp.subtitle' | 'whatsapp.title';
  'settings.notifications.email': 'subtitle' | 'title';
  'settings.notifications.push': 'subtitle' | 'title';
  'settings.notifications.sms': 'subtitle' | 'title';
  'settings.notifications.whatsapp': 'subtitle' | 'title';
  'settings.personal': 'info';
  'settings.phone': 'change.hint' | 'number';
  'settings.phone.change': 'hint';
  'support': 'blurb' | 'category.account' | 'category.billing' | 'category.complaint' | 'category.general' | 'category.inquiry' | 'category.label' | 'category.listing' | 'category.other' | 'category.technical' | 'errors.failed' | 'message.hint' | 'message.label' | 'message.placeholder' | 'seo.description' | 'seo.title' | 'submit' | 'title';
  'support.category': 'account' | 'billing' | 'complaint' | 'general' | 'inquiry' | 'label' | 'listing' | 'other' | 'technical';
  'support.errors': 'failed';
  'support.message': 'hint' | 'label' | 'placeholder';
  'support.seo': 'description' | 'title';
  'tools': 'affordability.advantages.points.0' | 'affordability.advantages.points.1' | 'affordability.advantages.points.2' | 'affordability.advantages.points.3' | 'affordability.advantages.title' | 'affordability.calculate' | 'affordability.calculator.notice' | 'affordability.calculator.title' | 'affordability.deposit' | 'affordability.explainer.blocks.0.body' | 'affordability.explainer.blocks.0.heading' | 'affordability.explainer.blocks.1.body' | 'affordability.explainer.blocks.1.heading' | 'affordability.explainer.blocks.2.body' | 'affordability.explainer.blocks.2.heading' | 'affordability.explainer.blocks.3.body' | 'affordability.explainer.blocks.3.heading' | 'affordability.explainer.title' | 'affordability.faqs.list.0.answer' | 'affordability.faqs.list.0.question' | 'affordability.faqs.list.1.answer' | 'affordability.faqs.list.1.question' | 'affordability.faqs.list.2.answer' | 'affordability.faqs.list.2.question' | 'affordability.faqs.list.3.answer' | 'affordability.faqs.list.3.question' | 'affordability.faqs.list.4.answer' | 'affordability.faqs.list.4.question' | 'affordability.faqs.list.5.answer' | 'affordability.faqs.list.5.question' | 'affordability.faqs.title' | 'affordability.howToUse.steps.0' | 'affordability.howToUse.steps.1' | 'affordability.howToUse.steps.2' | 'affordability.howToUse.steps.3' | 'affordability.howToUse.title' | 'affordability.interestRate' | 'affordability.monthlyIncome' | 'affordability.pageTitle' | 'affordability.related.buyVsRent' | 'affordability.related.mortgage' | 'affordability.related.ratesGovernmentRent' | 'affordability.related.stampDuty' | 'affordability.related.title' | 'affordability.results.boundByDeposit' | 'affordability.results.boundByIncome' | 'affordability.results.maxLoan' | 'affordability.results.maxPropertyPrice' | 'affordability.results.monthlyPayment' | 'affordability.seo.description' | 'affordability.seo.title' | 'affordability.subtitle' | 'affordability.termYears' | 'buyVsRent.analysisTool.buyingCost.title' | 'buyVsRent.analysisTool.calculate' | 'buyVsRent.analysisTool.rentingCost.title' | 'buyVsRent.analysisTool.title' | 'buyVsRent.breakevenMessage' | 'buyVsRent.buyOrRent.own' | 'buyVsRent.buyOrRent.ownOrRent' | 'buyVsRent.buyOrRent.rent' | 'buyVsRent.buyOrRent.title' | 'buyVsRent.buyOrRent.totalBuyingCost' | 'buyVsRent.buyOrRent.totalRentingCost' | 'buyVsRent.conclusion' | 'buyVsRent.disclaimer.details' | 'buyVsRent.disclaimer.title' | 'buyVsRent.fields.downPayment' | 'buyVsRent.fields.governmentRates' | 'buyVsRent.fields.governmentRent' | 'buyVsRent.fields.homeInsurance' | 'buyVsRent.fields.maintenanceFees' | 'buyVsRent.fields.mortgagePayment' | 'buyVsRent.fields.mortgageTermYears' | 'buyVsRent.fields.propertyPrice' | 'buyVsRent.fields.rent' | 'buyVsRent.fields.rentDurationYears' | 'buyVsRent.fields.rentIncreaseRate' | 'buyVsRent.howToUse.intro' | 'buyVsRent.howToUse.title' | 'buyVsRent.makeDecisionSmart.intro' | 'buyVsRent.makeDecisionSmart.title' | 'buyVsRent.needMoreAssistance.details' | 'buyVsRent.needMoreAssistance.title' | 'buyVsRent.pageTitle' | 'buyVsRent.readyToExplore.details' | 'buyVsRent.readyToExplore.title' | 'buyVsRent.seo.description' | 'buyVsRent.seo.title' | 'buyVsRent.subtitle' | 'chineseConverter.advantages.point1' | 'chineseConverter.advantages.point2' | 'chineseConverter.advantages.point3' | 'chineseConverter.advantages.point4' | 'chineseConverter.advantages.title' | 'chineseConverter.callToAction' | 'chineseConverter.converter.copy' | 'chineseConverter.converter.fieldLabel' | 'chineseConverter.converter.input' | 'chineseConverter.converter.inputPlaceholder' | 'chineseConverter.converter.output' | 'chineseConverter.converter.outputPlaceholder' | 'chineseConverter.converter.simplified' | 'chineseConverter.converter.submitButton' | 'chineseConverter.converter.title' | 'chineseConverter.converter.toSimplified' | 'chineseConverter.converter.toTraditional' | 'chineseConverter.converter.traditional' | 'chineseConverter.footerNote.p1' | 'chineseConverter.footerNote.p2' | 'chineseConverter.howToUse.step1' | 'chineseConverter.howToUse.step2' | 'chineseConverter.howToUse.step3' | 'chineseConverter.howToUse.step4' | 'chineseConverter.howToUse.title' | 'chineseConverter.pageTitle' | 'chineseConverter.seo.description' | 'chineseConverter.seo.title' | 'chineseConverter.subtitle' | 'index.affordability.description' | 'index.affordability.title' | 'index.buyVsRent.description' | 'index.buyVsRent.title' | 'index.calculators.title' | 'index.chineseConverter.description' | 'index.chineseConverter.title' | 'index.cta.button' | 'index.cta.description' | 'index.cta.title' | 'index.mortgage.description' | 'index.mortgage.title' | 'index.pageTitle' | 'index.ratesRent.description' | 'index.ratesRent.title' | 'index.rentalYield.description' | 'index.rentalYield.title' | 'index.seo.description' | 'index.seo.title' | 'index.stampDuty.description' | 'index.stampDuty.title' | 'index.subtitle' | 'index.templates.carPark.description' | 'index.templates.carPark.title' | 'index.templates.download' | 'index.templates.incomeProofSalaried.description' | 'index.templates.incomeProofSalaried.title' | 'index.templates.incomeProofSelf.description' | 'index.templates.incomeProofSelf.title' | 'index.templates.rentalChecklist.description' | 'index.templates.rentalChecklist.title' | 'index.templates.subtitle' | 'index.templates.surrenderAgreement.description' | 'index.templates.surrenderAgreement.title' | 'index.templates.tenancyAgreement.description' | 'index.templates.tenancyAgreement.title' | 'index.templates.title' | 'mortgage.advantages.points.0' | 'mortgage.advantages.points.1' | 'mortgage.advantages.points.2' | 'mortgage.advantages.points.3' | 'mortgage.advantages.points.4' | 'mortgage.advantages.title' | 'mortgage.calculate' | 'mortgage.calculator.notice' | 'mortgage.calculator.title' | 'mortgage.downPaymentPct' | 'mortgage.explainer.blocks.0.body' | 'mortgage.explainer.blocks.0.heading' | 'mortgage.explainer.blocks.1.body' | 'mortgage.explainer.blocks.1.heading' | 'mortgage.explainer.blocks.2.body' | 'mortgage.explainer.blocks.2.heading' | 'mortgage.explainer.blocks.3.body' | 'mortgage.explainer.blocks.3.heading' | 'mortgage.explainer.blocks.4.body' | 'mortgage.explainer.blocks.4.heading' | 'mortgage.explainer.blocks.5.body' | 'mortgage.explainer.blocks.5.heading' | 'mortgage.explainer.blocks.6.body' | 'mortgage.explainer.blocks.6.heading' | 'mortgage.explainer.title' | 'mortgage.faqs.list.0.answer' | 'mortgage.faqs.list.0.question' | 'mortgage.faqs.list.1.answer' | 'mortgage.faqs.list.1.question' | 'mortgage.faqs.list.2.answer' | 'mortgage.faqs.list.2.question' | 'mortgage.faqs.list.3.answer' | 'mortgage.faqs.list.3.question' | 'mortgage.faqs.list.4.answer' | 'mortgage.faqs.list.4.question' | 'mortgage.faqs.list.5.answer' | 'mortgage.faqs.list.5.question' | 'mortgage.faqs.list.6.answer' | 'mortgage.faqs.list.6.question' | 'mortgage.faqs.list.7.answer' | 'mortgage.faqs.list.7.question' | 'mortgage.faqs.title' | 'mortgage.howToUse.steps.0' | 'mortgage.howToUse.steps.1' | 'mortgage.howToUse.steps.2' | 'mortgage.howToUse.steps.3' | 'mortgage.howToUse.title' | 'mortgage.interestRate' | 'mortgage.pageTitle' | 'mortgage.propertyPrice' | 'mortgage.related.affordability' | 'mortgage.related.buyVsRent' | 'mortgage.related.ratesGovernmentRent' | 'mortgage.related.stampDuty' | 'mortgage.related.title' | 'mortgage.results.loanAmount' | 'mortgage.results.monthlyPayment' | 'mortgage.results.stressPayment' | 'mortgage.results.totalInterest' | 'mortgage.results.totalRepayment' | 'mortgage.seo.description' | 'mortgage.seo.title' | 'mortgage.subtitle' | 'mortgage.termYears' | 'ratesGovernmentRent.calculation.rateableValue.description' | 'ratesGovernmentRent.calculation.rateableValue.title' | 'ratesGovernmentRent.calculation.rates.collectionRate' | 'ratesGovernmentRent.calculation.rates.firstThreeQuarters' | 'ratesGovernmentRent.calculation.rates.fourthQuarter' | 'ratesGovernmentRent.calculation.rates.fourthQuarterStep1' | 'ratesGovernmentRent.calculation.rates.fourthQuarterStep2' | 'ratesGovernmentRent.calculation.rates.fourthQuarterStep3' | 'ratesGovernmentRent.calculation.rates.nonResidential' | 'ratesGovernmentRent.calculation.rates.rateableValueOver' | 'ratesGovernmentRent.calculation.rates.rateableValueUpTo' | 'ratesGovernmentRent.calculation.rates.residentialRates' | 'ratesGovernmentRent.calculation.rates.title' | 'ratesGovernmentRent.calculation.reductions.description' | 'ratesGovernmentRent.calculation.reductions.title' | 'ratesGovernmentRent.calculation.title' | 'ratesGovernmentRent.calculator.assessmentYear' | 'ratesGovernmentRent.calculator.calculate' | 'ratesGovernmentRent.calculator.nonResidential' | 'ratesGovernmentRent.calculator.propertyType' | 'ratesGovernmentRent.calculator.residential' | 'ratesGovernmentRent.calculator.title' | 'ratesGovernmentRent.calculator.totalQuarter1' | 'ratesGovernmentRent.calculator.totalQuarter2' | 'ratesGovernmentRent.calculator.totalQuarter3' | 'ratesGovernmentRent.calculator.totalQuarter4' | 'ratesGovernmentRent.disclaimer.description' | 'ratesGovernmentRent.disclaimer.title' | 'ratesGovernmentRent.exemptions.category1' | 'ratesGovernmentRent.exemptions.category2' | 'ratesGovernmentRent.exemptions.category3' | 'ratesGovernmentRent.exemptions.category4' | 'ratesGovernmentRent.exemptions.category5' | 'ratesGovernmentRent.exemptions.category6' | 'ratesGovernmentRent.exemptions.conclusion' | 'ratesGovernmentRent.exemptions.intro' | 'ratesGovernmentRent.exemptions.title' | 'ratesGovernmentRent.fields.rateableValue' | 'ratesGovernmentRent.howToUse.step1' | 'ratesGovernmentRent.howToUse.step2' | 'ratesGovernmentRent.howToUse.step3' | 'ratesGovernmentRent.howToUse.title' | 'ratesGovernmentRent.pageTitle' | 'ratesGovernmentRent.result.rates' | 'ratesGovernmentRent.result.reduction' | 'ratesGovernmentRent.result.rent' | 'ratesGovernmentRent.schedule.header1' | 'ratesGovernmentRent.schedule.header2' | 'ratesGovernmentRent.schedule.header3' | 'ratesGovernmentRent.schedule.rows.q1.delivery' | 'ratesGovernmentRent.schedule.rows.q1.payment' | 'ratesGovernmentRent.schedule.rows.q1.quarter' | 'ratesGovernmentRent.schedule.rows.q2.delivery' | 'ratesGovernmentRent.schedule.rows.q2.payment' | 'ratesGovernmentRent.schedule.rows.q2.quarter' | 'ratesGovernmentRent.schedule.rows.q3.delivery' | 'ratesGovernmentRent.schedule.rows.q3.payment' | 'ratesGovernmentRent.schedule.rows.q3.quarter' | 'ratesGovernmentRent.schedule.rows.q4.delivery' | 'ratesGovernmentRent.schedule.rows.q4.payment' | 'ratesGovernmentRent.schedule.rows.q4.quarter' | 'ratesGovernmentRent.schedule.title' | 'ratesGovernmentRent.seo.description' | 'ratesGovernmentRent.seo.title' | 'ratesGovernmentRent.subtitle' | 'ratesGovernmentRent.title' | 'ratesGovernmentRent.whyUse.step1' | 'ratesGovernmentRent.whyUse.step2' | 'ratesGovernmentRent.whyUse.step3' | 'ratesGovernmentRent.whyUse.step4' | 'ratesGovernmentRent.whyUse.step5' | 'ratesGovernmentRent.whyUse.title' | 'rentalYield.calculator.annualReturn' | 'rentalYield.calculator.calculateRentalYield' | 'rentalYield.calculator.rentalYieldLabel' | 'rentalYield.calculator.title' | 'rentalYield.calculator.titleAdvanced' | 'rentalYield.conclusion.description' | 'rentalYield.conclusion.title' | 'rentalYield.disclaimer.description' | 'rentalYield.disclaimer.title' | 'rentalYield.fields.expensesHint' | 'rentalYield.fields.monthlyExpenses' | 'rentalYield.fields.monthlyRent' | 'rentalYield.fields.propertyPrice' | 'rentalYield.howToChoose.description' | 'rentalYield.howToChoose.title' | 'rentalYield.howToChooseHighReturn.description' | 'rentalYield.howToChooseHighReturn.title' | 'rentalYield.howToUse.intro' | 'rentalYield.howToUse.step1' | 'rentalYield.howToUse.step2' | 'rentalYield.howToUse.step3' | 'rentalYield.howToUse.title' | 'rentalYield.pageTitle' | 'rentalYield.seo.description' | 'rentalYield.seo.title' | 'rentalYield.subtitle' | 'stampDuty.advantages.points.0' | 'stampDuty.advantages.points.1' | 'stampDuty.advantages.points.2' | 'stampDuty.advantages.points.3' | 'stampDuty.advantages.points.4' | 'stampDuty.advantages.title' | 'stampDuty.averageYearlyRent' | 'stampDuty.calculate' | 'stampDuty.calculator.notice' | 'stampDuty.calculator.title' | 'stampDuty.endDate' | 'stampDuty.explainer.blocks.0.body' | 'stampDuty.explainer.blocks.0.heading' | 'stampDuty.explainer.blocks.1.body' | 'stampDuty.explainer.blocks.1.heading' | 'stampDuty.explainer.blocks.2.body' | 'stampDuty.explainer.blocks.2.heading' | 'stampDuty.explainer.blocks.3.body' | 'stampDuty.explainer.blocks.3.heading' | 'stampDuty.explainer.blocks.4.body' | 'stampDuty.explainer.blocks.4.heading' | 'stampDuty.explainer.blocks.5.body' | 'stampDuty.explainer.blocks.5.heading' | 'stampDuty.explainer.title' | 'stampDuty.faqs.list.0.answer' | 'stampDuty.faqs.list.0.question' | 'stampDuty.faqs.list.1.answer' | 'stampDuty.faqs.list.1.question' | 'stampDuty.faqs.list.2.answer' | 'stampDuty.faqs.list.2.question' | 'stampDuty.faqs.list.3.answer' | 'stampDuty.faqs.list.3.question' | 'stampDuty.faqs.list.4.answer' | 'stampDuty.faqs.list.4.question' | 'stampDuty.faqs.list.5.answer' | 'stampDuty.faqs.list.5.question' | 'stampDuty.faqs.list.6.answer' | 'stampDuty.faqs.list.6.question' | 'stampDuty.faqs.list.7.answer' | 'stampDuty.faqs.list.7.question' | 'stampDuty.faqs.title' | 'stampDuty.fixedLease' | 'stampDuty.howToUse.steps.0' | 'stampDuty.howToUse.steps.1' | 'stampDuty.howToUse.steps.2' | 'stampDuty.howToUse.steps.3' | 'stampDuty.howToUse.title' | 'stampDuty.leaseType' | 'stampDuty.monthlyRent' | 'stampDuty.nonFixedLease' | 'stampDuty.pageTitle' | 'stampDuty.rates.basisAverageYearly' | 'stampDuty.rates.basisHeader' | 'stampDuty.rates.basisTotalRent' | 'stampDuty.rates.counterpart' | 'stampDuty.rates.intro' | 'stampDuty.rates.rateHeader' | 'stampDuty.rates.termAbove' | 'stampDuty.rates.termBetween' | 'stampDuty.rates.termHeader' | 'stampDuty.rates.termNonFixed' | 'stampDuty.rates.termUpTo' | 'stampDuty.rates.title' | 'stampDuty.related.buyVsRent' | 'stampDuty.related.mortgage' | 'stampDuty.related.ratesGovernmentRent' | 'stampDuty.related.rentalYield' | 'stampDuty.related.title' | 'stampDuty.seo.description' | 'stampDuty.seo.title' | 'stampDuty.stampDutyPayable' | 'stampDuty.startDate' | 'stampDuty.subtitle' | 'stampDuty.title';
  'tools.affordability': 'advantages.points.0' | 'advantages.points.1' | 'advantages.points.2' | 'advantages.points.3' | 'advantages.title' | 'calculate' | 'calculator.notice' | 'calculator.title' | 'deposit' | 'explainer.blocks.0.body' | 'explainer.blocks.0.heading' | 'explainer.blocks.1.body' | 'explainer.blocks.1.heading' | 'explainer.blocks.2.body' | 'explainer.blocks.2.heading' | 'explainer.blocks.3.body' | 'explainer.blocks.3.heading' | 'explainer.title' | 'faqs.list.0.answer' | 'faqs.list.0.question' | 'faqs.list.1.answer' | 'faqs.list.1.question' | 'faqs.list.2.answer' | 'faqs.list.2.question' | 'faqs.list.3.answer' | 'faqs.list.3.question' | 'faqs.list.4.answer' | 'faqs.list.4.question' | 'faqs.list.5.answer' | 'faqs.list.5.question' | 'faqs.title' | 'howToUse.steps.0' | 'howToUse.steps.1' | 'howToUse.steps.2' | 'howToUse.steps.3' | 'howToUse.title' | 'interestRate' | 'monthlyIncome' | 'pageTitle' | 'related.buyVsRent' | 'related.mortgage' | 'related.ratesGovernmentRent' | 'related.stampDuty' | 'related.title' | 'results.boundByDeposit' | 'results.boundByIncome' | 'results.maxLoan' | 'results.maxPropertyPrice' | 'results.monthlyPayment' | 'seo.description' | 'seo.title' | 'subtitle' | 'termYears';
  'tools.affordability.advantages': 'points.0' | 'points.1' | 'points.2' | 'points.3' | 'title';
  'tools.affordability.advantages.points': '0' | '1' | '2' | '3';
  'tools.affordability.calculator': 'notice' | 'title';
  'tools.affordability.explainer': 'blocks.0.body' | 'blocks.0.heading' | 'blocks.1.body' | 'blocks.1.heading' | 'blocks.2.body' | 'blocks.2.heading' | 'blocks.3.body' | 'blocks.3.heading' | 'title';
  'tools.affordability.explainer.blocks': '0.body' | '0.heading' | '1.body' | '1.heading' | '2.body' | '2.heading' | '3.body' | '3.heading';
  'tools.affordability.explainer.blocks.0': 'body' | 'heading';
  'tools.affordability.explainer.blocks.1': 'body' | 'heading';
  'tools.affordability.explainer.blocks.2': 'body' | 'heading';
  'tools.affordability.explainer.blocks.3': 'body' | 'heading';
  'tools.affordability.faqs': 'list.0.answer' | 'list.0.question' | 'list.1.answer' | 'list.1.question' | 'list.2.answer' | 'list.2.question' | 'list.3.answer' | 'list.3.question' | 'list.4.answer' | 'list.4.question' | 'list.5.answer' | 'list.5.question' | 'title';
  'tools.affordability.faqs.list': '0.answer' | '0.question' | '1.answer' | '1.question' | '2.answer' | '2.question' | '3.answer' | '3.question' | '4.answer' | '4.question' | '5.answer' | '5.question';
  'tools.affordability.faqs.list.0': 'answer' | 'question';
  'tools.affordability.faqs.list.1': 'answer' | 'question';
  'tools.affordability.faqs.list.2': 'answer' | 'question';
  'tools.affordability.faqs.list.3': 'answer' | 'question';
  'tools.affordability.faqs.list.4': 'answer' | 'question';
  'tools.affordability.faqs.list.5': 'answer' | 'question';
  'tools.affordability.howToUse': 'steps.0' | 'steps.1' | 'steps.2' | 'steps.3' | 'title';
  'tools.affordability.howToUse.steps': '0' | '1' | '2' | '3';
  'tools.affordability.related': 'buyVsRent' | 'mortgage' | 'ratesGovernmentRent' | 'stampDuty' | 'title';
  'tools.affordability.results': 'boundByDeposit' | 'boundByIncome' | 'maxLoan' | 'maxPropertyPrice' | 'monthlyPayment';
  'tools.affordability.seo': 'description' | 'title';
  'tools.buyVsRent': 'analysisTool.buyingCost.title' | 'analysisTool.calculate' | 'analysisTool.rentingCost.title' | 'analysisTool.title' | 'breakevenMessage' | 'buyOrRent.own' | 'buyOrRent.ownOrRent' | 'buyOrRent.rent' | 'buyOrRent.title' | 'buyOrRent.totalBuyingCost' | 'buyOrRent.totalRentingCost' | 'conclusion' | 'disclaimer.details' | 'disclaimer.title' | 'fields.downPayment' | 'fields.governmentRates' | 'fields.governmentRent' | 'fields.homeInsurance' | 'fields.maintenanceFees' | 'fields.mortgagePayment' | 'fields.mortgageTermYears' | 'fields.propertyPrice' | 'fields.rent' | 'fields.rentDurationYears' | 'fields.rentIncreaseRate' | 'howToUse.intro' | 'howToUse.title' | 'makeDecisionSmart.intro' | 'makeDecisionSmart.title' | 'needMoreAssistance.details' | 'needMoreAssistance.title' | 'pageTitle' | 'readyToExplore.details' | 'readyToExplore.title' | 'seo.description' | 'seo.title' | 'subtitle';
  'tools.buyVsRent.analysisTool': 'buyingCost.title' | 'calculate' | 'rentingCost.title' | 'title';
  'tools.buyVsRent.analysisTool.buyingCost': 'title';
  'tools.buyVsRent.analysisTool.rentingCost': 'title';
  'tools.buyVsRent.buyOrRent': 'own' | 'ownOrRent' | 'rent' | 'title' | 'totalBuyingCost' | 'totalRentingCost';
  'tools.buyVsRent.disclaimer': 'details' | 'title';
  'tools.buyVsRent.fields': 'downPayment' | 'governmentRates' | 'governmentRent' | 'homeInsurance' | 'maintenanceFees' | 'mortgagePayment' | 'mortgageTermYears' | 'propertyPrice' | 'rent' | 'rentDurationYears' | 'rentIncreaseRate';
  'tools.buyVsRent.howToUse': 'intro' | 'title';
  'tools.buyVsRent.makeDecisionSmart': 'intro' | 'title';
  'tools.buyVsRent.needMoreAssistance': 'details' | 'title';
  'tools.buyVsRent.readyToExplore': 'details' | 'title';
  'tools.buyVsRent.seo': 'description' | 'title';
  'tools.chineseConverter': 'advantages.point1' | 'advantages.point2' | 'advantages.point3' | 'advantages.point4' | 'advantages.title' | 'callToAction' | 'converter.copy' | 'converter.fieldLabel' | 'converter.input' | 'converter.inputPlaceholder' | 'converter.output' | 'converter.outputPlaceholder' | 'converter.simplified' | 'converter.submitButton' | 'converter.title' | 'converter.toSimplified' | 'converter.toTraditional' | 'converter.traditional' | 'footerNote.p1' | 'footerNote.p2' | 'howToUse.step1' | 'howToUse.step2' | 'howToUse.step3' | 'howToUse.step4' | 'howToUse.title' | 'pageTitle' | 'seo.description' | 'seo.title' | 'subtitle';
  'tools.chineseConverter.advantages': 'point1' | 'point2' | 'point3' | 'point4' | 'title';
  'tools.chineseConverter.converter': 'copy' | 'fieldLabel' | 'input' | 'inputPlaceholder' | 'output' | 'outputPlaceholder' | 'simplified' | 'submitButton' | 'title' | 'toSimplified' | 'toTraditional' | 'traditional';
  'tools.chineseConverter.footerNote': 'p1' | 'p2';
  'tools.chineseConverter.howToUse': 'step1' | 'step2' | 'step3' | 'step4' | 'title';
  'tools.chineseConverter.seo': 'description' | 'title';
  'tools.index': 'affordability.description' | 'affordability.title' | 'buyVsRent.description' | 'buyVsRent.title' | 'calculators.title' | 'chineseConverter.description' | 'chineseConverter.title' | 'cta.button' | 'cta.description' | 'cta.title' | 'mortgage.description' | 'mortgage.title' | 'pageTitle' | 'ratesRent.description' | 'ratesRent.title' | 'rentalYield.description' | 'rentalYield.title' | 'seo.description' | 'seo.title' | 'stampDuty.description' | 'stampDuty.title' | 'subtitle' | 'templates.carPark.description' | 'templates.carPark.title' | 'templates.download' | 'templates.incomeProofSalaried.description' | 'templates.incomeProofSalaried.title' | 'templates.incomeProofSelf.description' | 'templates.incomeProofSelf.title' | 'templates.rentalChecklist.description' | 'templates.rentalChecklist.title' | 'templates.subtitle' | 'templates.surrenderAgreement.description' | 'templates.surrenderAgreement.title' | 'templates.tenancyAgreement.description' | 'templates.tenancyAgreement.title' | 'templates.title';
  'tools.index.affordability': 'description' | 'title';
  'tools.index.buyVsRent': 'description' | 'title';
  'tools.index.calculators': 'title';
  'tools.index.chineseConverter': 'description' | 'title';
  'tools.index.cta': 'button' | 'description' | 'title';
  'tools.index.mortgage': 'description' | 'title';
  'tools.index.ratesRent': 'description' | 'title';
  'tools.index.rentalYield': 'description' | 'title';
  'tools.index.seo': 'description' | 'title';
  'tools.index.stampDuty': 'description' | 'title';
  'tools.index.templates': 'carPark.description' | 'carPark.title' | 'download' | 'incomeProofSalaried.description' | 'incomeProofSalaried.title' | 'incomeProofSelf.description' | 'incomeProofSelf.title' | 'rentalChecklist.description' | 'rentalChecklist.title' | 'subtitle' | 'surrenderAgreement.description' | 'surrenderAgreement.title' | 'tenancyAgreement.description' | 'tenancyAgreement.title' | 'title';
  'tools.index.templates.carPark': 'description' | 'title';
  'tools.index.templates.incomeProofSalaried': 'description' | 'title';
  'tools.index.templates.incomeProofSelf': 'description' | 'title';
  'tools.index.templates.rentalChecklist': 'description' | 'title';
  'tools.index.templates.surrenderAgreement': 'description' | 'title';
  'tools.index.templates.tenancyAgreement': 'description' | 'title';
  'tools.mortgage': 'advantages.points.0' | 'advantages.points.1' | 'advantages.points.2' | 'advantages.points.3' | 'advantages.points.4' | 'advantages.title' | 'calculate' | 'calculator.notice' | 'calculator.title' | 'downPaymentPct' | 'explainer.blocks.0.body' | 'explainer.blocks.0.heading' | 'explainer.blocks.1.body' | 'explainer.blocks.1.heading' | 'explainer.blocks.2.body' | 'explainer.blocks.2.heading' | 'explainer.blocks.3.body' | 'explainer.blocks.3.heading' | 'explainer.blocks.4.body' | 'explainer.blocks.4.heading' | 'explainer.blocks.5.body' | 'explainer.blocks.5.heading' | 'explainer.blocks.6.body' | 'explainer.blocks.6.heading' | 'explainer.title' | 'faqs.list.0.answer' | 'faqs.list.0.question' | 'faqs.list.1.answer' | 'faqs.list.1.question' | 'faqs.list.2.answer' | 'faqs.list.2.question' | 'faqs.list.3.answer' | 'faqs.list.3.question' | 'faqs.list.4.answer' | 'faqs.list.4.question' | 'faqs.list.5.answer' | 'faqs.list.5.question' | 'faqs.list.6.answer' | 'faqs.list.6.question' | 'faqs.list.7.answer' | 'faqs.list.7.question' | 'faqs.title' | 'howToUse.steps.0' | 'howToUse.steps.1' | 'howToUse.steps.2' | 'howToUse.steps.3' | 'howToUse.title' | 'interestRate' | 'pageTitle' | 'propertyPrice' | 'related.affordability' | 'related.buyVsRent' | 'related.ratesGovernmentRent' | 'related.stampDuty' | 'related.title' | 'results.loanAmount' | 'results.monthlyPayment' | 'results.stressPayment' | 'results.totalInterest' | 'results.totalRepayment' | 'seo.description' | 'seo.title' | 'subtitle' | 'termYears';
  'tools.mortgage.advantages': 'points.0' | 'points.1' | 'points.2' | 'points.3' | 'points.4' | 'title';
  'tools.mortgage.advantages.points': '0' | '1' | '2' | '3' | '4';
  'tools.mortgage.calculator': 'notice' | 'title';
  'tools.mortgage.explainer': 'blocks.0.body' | 'blocks.0.heading' | 'blocks.1.body' | 'blocks.1.heading' | 'blocks.2.body' | 'blocks.2.heading' | 'blocks.3.body' | 'blocks.3.heading' | 'blocks.4.body' | 'blocks.4.heading' | 'blocks.5.body' | 'blocks.5.heading' | 'blocks.6.body' | 'blocks.6.heading' | 'title';
  'tools.mortgage.explainer.blocks': '0.body' | '0.heading' | '1.body' | '1.heading' | '2.body' | '2.heading' | '3.body' | '3.heading' | '4.body' | '4.heading' | '5.body' | '5.heading' | '6.body' | '6.heading';
  'tools.mortgage.explainer.blocks.0': 'body' | 'heading';
  'tools.mortgage.explainer.blocks.1': 'body' | 'heading';
  'tools.mortgage.explainer.blocks.2': 'body' | 'heading';
  'tools.mortgage.explainer.blocks.3': 'body' | 'heading';
  'tools.mortgage.explainer.blocks.4': 'body' | 'heading';
  'tools.mortgage.explainer.blocks.5': 'body' | 'heading';
  'tools.mortgage.explainer.blocks.6': 'body' | 'heading';
  'tools.mortgage.faqs': 'list.0.answer' | 'list.0.question' | 'list.1.answer' | 'list.1.question' | 'list.2.answer' | 'list.2.question' | 'list.3.answer' | 'list.3.question' | 'list.4.answer' | 'list.4.question' | 'list.5.answer' | 'list.5.question' | 'list.6.answer' | 'list.6.question' | 'list.7.answer' | 'list.7.question' | 'title';
  'tools.mortgage.faqs.list': '0.answer' | '0.question' | '1.answer' | '1.question' | '2.answer' | '2.question' | '3.answer' | '3.question' | '4.answer' | '4.question' | '5.answer' | '5.question' | '6.answer' | '6.question' | '7.answer' | '7.question';
  'tools.mortgage.faqs.list.0': 'answer' | 'question';
  'tools.mortgage.faqs.list.1': 'answer' | 'question';
  'tools.mortgage.faqs.list.2': 'answer' | 'question';
  'tools.mortgage.faqs.list.3': 'answer' | 'question';
  'tools.mortgage.faqs.list.4': 'answer' | 'question';
  'tools.mortgage.faqs.list.5': 'answer' | 'question';
  'tools.mortgage.faqs.list.6': 'answer' | 'question';
  'tools.mortgage.faqs.list.7': 'answer' | 'question';
  'tools.mortgage.howToUse': 'steps.0' | 'steps.1' | 'steps.2' | 'steps.3' | 'title';
  'tools.mortgage.howToUse.steps': '0' | '1' | '2' | '3';
  'tools.mortgage.related': 'affordability' | 'buyVsRent' | 'ratesGovernmentRent' | 'stampDuty' | 'title';
  'tools.mortgage.results': 'loanAmount' | 'monthlyPayment' | 'stressPayment' | 'totalInterest' | 'totalRepayment';
  'tools.mortgage.seo': 'description' | 'title';
  'tools.ratesGovernmentRent': 'calculation.rateableValue.description' | 'calculation.rateableValue.title' | 'calculation.rates.collectionRate' | 'calculation.rates.firstThreeQuarters' | 'calculation.rates.fourthQuarter' | 'calculation.rates.fourthQuarterStep1' | 'calculation.rates.fourthQuarterStep2' | 'calculation.rates.fourthQuarterStep3' | 'calculation.rates.nonResidential' | 'calculation.rates.rateableValueOver' | 'calculation.rates.rateableValueUpTo' | 'calculation.rates.residentialRates' | 'calculation.rates.title' | 'calculation.reductions.description' | 'calculation.reductions.title' | 'calculation.title' | 'calculator.assessmentYear' | 'calculator.calculate' | 'calculator.nonResidential' | 'calculator.propertyType' | 'calculator.residential' | 'calculator.title' | 'calculator.totalQuarter1' | 'calculator.totalQuarter2' | 'calculator.totalQuarter3' | 'calculator.totalQuarter4' | 'disclaimer.description' | 'disclaimer.title' | 'exemptions.category1' | 'exemptions.category2' | 'exemptions.category3' | 'exemptions.category4' | 'exemptions.category5' | 'exemptions.category6' | 'exemptions.conclusion' | 'exemptions.intro' | 'exemptions.title' | 'fields.rateableValue' | 'howToUse.step1' | 'howToUse.step2' | 'howToUse.step3' | 'howToUse.title' | 'pageTitle' | 'result.rates' | 'result.reduction' | 'result.rent' | 'schedule.header1' | 'schedule.header2' | 'schedule.header3' | 'schedule.rows.q1.delivery' | 'schedule.rows.q1.payment' | 'schedule.rows.q1.quarter' | 'schedule.rows.q2.delivery' | 'schedule.rows.q2.payment' | 'schedule.rows.q2.quarter' | 'schedule.rows.q3.delivery' | 'schedule.rows.q3.payment' | 'schedule.rows.q3.quarter' | 'schedule.rows.q4.delivery' | 'schedule.rows.q4.payment' | 'schedule.rows.q4.quarter' | 'schedule.title' | 'seo.description' | 'seo.title' | 'subtitle' | 'title' | 'whyUse.step1' | 'whyUse.step2' | 'whyUse.step3' | 'whyUse.step4' | 'whyUse.step5' | 'whyUse.title';
  'tools.ratesGovernmentRent.calculation': 'rateableValue.description' | 'rateableValue.title' | 'rates.collectionRate' | 'rates.firstThreeQuarters' | 'rates.fourthQuarter' | 'rates.fourthQuarterStep1' | 'rates.fourthQuarterStep2' | 'rates.fourthQuarterStep3' | 'rates.nonResidential' | 'rates.rateableValueOver' | 'rates.rateableValueUpTo' | 'rates.residentialRates' | 'rates.title' | 'reductions.description' | 'reductions.title' | 'title';
  'tools.ratesGovernmentRent.calculation.rateableValue': 'description' | 'title';
  'tools.ratesGovernmentRent.calculation.rates': 'collectionRate' | 'firstThreeQuarters' | 'fourthQuarter' | 'fourthQuarterStep1' | 'fourthQuarterStep2' | 'fourthQuarterStep3' | 'nonResidential' | 'rateableValueOver' | 'rateableValueUpTo' | 'residentialRates' | 'title';
  'tools.ratesGovernmentRent.calculation.reductions': 'description' | 'title';
  'tools.ratesGovernmentRent.calculator': 'assessmentYear' | 'calculate' | 'nonResidential' | 'propertyType' | 'residential' | 'title' | 'totalQuarter1' | 'totalQuarter2' | 'totalQuarter3' | 'totalQuarter4';
  'tools.ratesGovernmentRent.disclaimer': 'description' | 'title';
  'tools.ratesGovernmentRent.exemptions': 'category1' | 'category2' | 'category3' | 'category4' | 'category5' | 'category6' | 'conclusion' | 'intro' | 'title';
  'tools.ratesGovernmentRent.fields': 'rateableValue';
  'tools.ratesGovernmentRent.howToUse': 'step1' | 'step2' | 'step3' | 'title';
  'tools.ratesGovernmentRent.result': 'rates' | 'reduction' | 'rent';
  'tools.ratesGovernmentRent.schedule': 'header1' | 'header2' | 'header3' | 'rows.q1.delivery' | 'rows.q1.payment' | 'rows.q1.quarter' | 'rows.q2.delivery' | 'rows.q2.payment' | 'rows.q2.quarter' | 'rows.q3.delivery' | 'rows.q3.payment' | 'rows.q3.quarter' | 'rows.q4.delivery' | 'rows.q4.payment' | 'rows.q4.quarter' | 'title';
  'tools.ratesGovernmentRent.schedule.rows': 'q1.delivery' | 'q1.payment' | 'q1.quarter' | 'q2.delivery' | 'q2.payment' | 'q2.quarter' | 'q3.delivery' | 'q3.payment' | 'q3.quarter' | 'q4.delivery' | 'q4.payment' | 'q4.quarter';
  'tools.ratesGovernmentRent.schedule.rows.q1': 'delivery' | 'payment' | 'quarter';
  'tools.ratesGovernmentRent.schedule.rows.q2': 'delivery' | 'payment' | 'quarter';
  'tools.ratesGovernmentRent.schedule.rows.q3': 'delivery' | 'payment' | 'quarter';
  'tools.ratesGovernmentRent.schedule.rows.q4': 'delivery' | 'payment' | 'quarter';
  'tools.ratesGovernmentRent.seo': 'description' | 'title';
  'tools.ratesGovernmentRent.whyUse': 'step1' | 'step2' | 'step3' | 'step4' | 'step5' | 'title';
  'tools.rentalYield': 'calculator.annualReturn' | 'calculator.calculateRentalYield' | 'calculator.rentalYieldLabel' | 'calculator.title' | 'calculator.titleAdvanced' | 'conclusion.description' | 'conclusion.title' | 'disclaimer.description' | 'disclaimer.title' | 'fields.expensesHint' | 'fields.monthlyExpenses' | 'fields.monthlyRent' | 'fields.propertyPrice' | 'howToChoose.description' | 'howToChoose.title' | 'howToChooseHighReturn.description' | 'howToChooseHighReturn.title' | 'howToUse.intro' | 'howToUse.step1' | 'howToUse.step2' | 'howToUse.step3' | 'howToUse.title' | 'pageTitle' | 'seo.description' | 'seo.title' | 'subtitle';
  'tools.rentalYield.calculator': 'annualReturn' | 'calculateRentalYield' | 'rentalYieldLabel' | 'title' | 'titleAdvanced';
  'tools.rentalYield.conclusion': 'description' | 'title';
  'tools.rentalYield.disclaimer': 'description' | 'title';
  'tools.rentalYield.fields': 'expensesHint' | 'monthlyExpenses' | 'monthlyRent' | 'propertyPrice';
  'tools.rentalYield.howToChoose': 'description' | 'title';
  'tools.rentalYield.howToChooseHighReturn': 'description' | 'title';
  'tools.rentalYield.howToUse': 'intro' | 'step1' | 'step2' | 'step3' | 'title';
  'tools.rentalYield.seo': 'description' | 'title';
  'tools.stampDuty': 'advantages.points.0' | 'advantages.points.1' | 'advantages.points.2' | 'advantages.points.3' | 'advantages.points.4' | 'advantages.title' | 'averageYearlyRent' | 'calculate' | 'calculator.notice' | 'calculator.title' | 'endDate' | 'explainer.blocks.0.body' | 'explainer.blocks.0.heading' | 'explainer.blocks.1.body' | 'explainer.blocks.1.heading' | 'explainer.blocks.2.body' | 'explainer.blocks.2.heading' | 'explainer.blocks.3.body' | 'explainer.blocks.3.heading' | 'explainer.blocks.4.body' | 'explainer.blocks.4.heading' | 'explainer.blocks.5.body' | 'explainer.blocks.5.heading' | 'explainer.title' | 'faqs.list.0.answer' | 'faqs.list.0.question' | 'faqs.list.1.answer' | 'faqs.list.1.question' | 'faqs.list.2.answer' | 'faqs.list.2.question' | 'faqs.list.3.answer' | 'faqs.list.3.question' | 'faqs.list.4.answer' | 'faqs.list.4.question' | 'faqs.list.5.answer' | 'faqs.list.5.question' | 'faqs.list.6.answer' | 'faqs.list.6.question' | 'faqs.list.7.answer' | 'faqs.list.7.question' | 'faqs.title' | 'fixedLease' | 'howToUse.steps.0' | 'howToUse.steps.1' | 'howToUse.steps.2' | 'howToUse.steps.3' | 'howToUse.title' | 'leaseType' | 'monthlyRent' | 'nonFixedLease' | 'pageTitle' | 'rates.basisAverageYearly' | 'rates.basisHeader' | 'rates.basisTotalRent' | 'rates.counterpart' | 'rates.intro' | 'rates.rateHeader' | 'rates.termAbove' | 'rates.termBetween' | 'rates.termHeader' | 'rates.termNonFixed' | 'rates.termUpTo' | 'rates.title' | 'related.buyVsRent' | 'related.mortgage' | 'related.ratesGovernmentRent' | 'related.rentalYield' | 'related.title' | 'seo.description' | 'seo.title' | 'stampDutyPayable' | 'startDate' | 'subtitle' | 'title';
  'tools.stampDuty.advantages': 'points.0' | 'points.1' | 'points.2' | 'points.3' | 'points.4' | 'title';
  'tools.stampDuty.advantages.points': '0' | '1' | '2' | '3' | '4';
  'tools.stampDuty.calculator': 'notice' | 'title';
  'tools.stampDuty.explainer': 'blocks.0.body' | 'blocks.0.heading' | 'blocks.1.body' | 'blocks.1.heading' | 'blocks.2.body' | 'blocks.2.heading' | 'blocks.3.body' | 'blocks.3.heading' | 'blocks.4.body' | 'blocks.4.heading' | 'blocks.5.body' | 'blocks.5.heading' | 'title';
  'tools.stampDuty.explainer.blocks': '0.body' | '0.heading' | '1.body' | '1.heading' | '2.body' | '2.heading' | '3.body' | '3.heading' | '4.body' | '4.heading' | '5.body' | '5.heading';
  'tools.stampDuty.explainer.blocks.0': 'body' | 'heading';
  'tools.stampDuty.explainer.blocks.1': 'body' | 'heading';
  'tools.stampDuty.explainer.blocks.2': 'body' | 'heading';
  'tools.stampDuty.explainer.blocks.3': 'body' | 'heading';
  'tools.stampDuty.explainer.blocks.4': 'body' | 'heading';
  'tools.stampDuty.explainer.blocks.5': 'body' | 'heading';
  'tools.stampDuty.faqs': 'list.0.answer' | 'list.0.question' | 'list.1.answer' | 'list.1.question' | 'list.2.answer' | 'list.2.question' | 'list.3.answer' | 'list.3.question' | 'list.4.answer' | 'list.4.question' | 'list.5.answer' | 'list.5.question' | 'list.6.answer' | 'list.6.question' | 'list.7.answer' | 'list.7.question' | 'title';
  'tools.stampDuty.faqs.list': '0.answer' | '0.question' | '1.answer' | '1.question' | '2.answer' | '2.question' | '3.answer' | '3.question' | '4.answer' | '4.question' | '5.answer' | '5.question' | '6.answer' | '6.question' | '7.answer' | '7.question';
  'tools.stampDuty.faqs.list.0': 'answer' | 'question';
  'tools.stampDuty.faqs.list.1': 'answer' | 'question';
  'tools.stampDuty.faqs.list.2': 'answer' | 'question';
  'tools.stampDuty.faqs.list.3': 'answer' | 'question';
  'tools.stampDuty.faqs.list.4': 'answer' | 'question';
  'tools.stampDuty.faqs.list.5': 'answer' | 'question';
  'tools.stampDuty.faqs.list.6': 'answer' | 'question';
  'tools.stampDuty.faqs.list.7': 'answer' | 'question';
  'tools.stampDuty.howToUse': 'steps.0' | 'steps.1' | 'steps.2' | 'steps.3' | 'title';
  'tools.stampDuty.howToUse.steps': '0' | '1' | '2' | '3';
  'tools.stampDuty.rates': 'basisAverageYearly' | 'basisHeader' | 'basisTotalRent' | 'counterpart' | 'intro' | 'rateHeader' | 'termAbove' | 'termBetween' | 'termHeader' | 'termNonFixed' | 'termUpTo' | 'title';
  'tools.stampDuty.related': 'buyVsRent' | 'mortgage' | 'ratesGovernmentRent' | 'rentalYield' | 'title';
  'tools.stampDuty.seo': 'description' | 'title';
  'transactions': 'area' | 'backToEstate' | 'date' | 'empty' | 'emptyEstate' | 'estate' | 'floor' | 'kind' | 'perSqft' | 'price' | 'recentDeals' | 'recentDealsNote' | 'seeAll' | 'source' | 'sqft' | 'subtitle' | 'unlinkedEstate';
  'wizard': 'address.buildingLabel' | 'address.buildingPlaceholder' | 'address.changeBuildingAction' | 'address.description' | 'address.estateLabel' | 'address.floor.label' | 'address.floor.placeholder' | 'address.floorLevel.higher' | 'address.floorLevel.hint' | 'address.floorLevel.label' | 'address.floorLevel.lower' | 'address.floorLevel.middle' | 'address.loadingBuildings' | 'address.manualEntryLink' | 'address.manualHint' | 'address.manualLabel' | 'address.manualPlaceholder' | 'address.manualReviewNote' | 'address.noBuildingsHint' | 'address.noBuildingsTitle' | 'address.otherPhasesAction' | 'address.phaseLabel' | 'address.phasePlaceholder' | 'address.search.clear' | 'address.search.emptyAction' | 'address.search.emptyHint' | 'address.search.emptyTitle' | 'address.search.errorHint' | 'address.search.errorTitle' | 'address.search.hint' | 'address.search.loading' | 'address.search.multiPhase' | 'address.search.placeholder' | 'address.searchLink' | 'address.structureErrorHint' | 'address.structureErrorTitle' | 'address.title' | 'address.unit.label' | 'address.unit.placeholder' | 'amenities.description' | 'amenities.title' | 'description.description' | 'description.hint' | 'description.label' | 'description.placeholder' | 'description.title' | 'errors.incomplete' | 'exitButton' | 'exitButtonIntro' | 'exitTooltip' | 'footer.back' | 'footer.next' | 'footer.publish' | 'media.add' | 'media.cover' | 'media.dropzone.subtitle' | 'media.photoAlt' | 'media.photosDone' | 'media.photosProgress' | 'media.rejected.tooLarge' | 'media.rejected.unsupportedType' | 'media.remove' | 'media.retry' | 'media.title' | 'media.uploadFailed' | 'payment.cancelled' | 'payment.checkAgain' | 'payment.confirming' | 'payment.expired' | 'payment.explainer' | 'payment.paid' | 'payment.payButton' | 'payment.pendingHint' | 'payment.publishButton' | 'payment.publishIncomplete' | 'payment.refunded' | 'payment.startError' | 'payment.statusError' | 'payment.title' | 'pricing.description' | 'pricing.forRentLabel' | 'pricing.forSaleLabel' | 'pricing.rentPriceLabel' | 'pricing.rentPricePlaceholder' | 'pricing.salePriceLabel' | 'pricing.salePricePlaceholder' | 'pricing.title' | 'size.bathroomsLabel' | 'size.bedroomsLabel' | 'size.description' | 'size.pets.hint' | 'size.pets.label' | 'size.pets.unspecified' | 'size.propertyType.hint' | 'size.propertyType.label' | 'size.propertyType.options.detachedHouse' | 'size.propertyType.options.estateFlat' | 'size.propertyType.options.publicHousing' | 'size.propertyType.options.servicedApartment' | 'size.propertyType.options.singleBlockFlat' | 'size.propertyType.options.subsidisedHos' | 'size.propertyType.options.tongLau' | 'size.propertyType.options.villageHouse' | 'size.propertyType.options.walkUp' | 'size.roomsHint' | 'size.saleableAreaLabel' | 'size.saleableAreaPlaceholder' | 'size.studio' | 'size.title' | 'toast.publishError' | 'toast.publishSuccess';
  'wizard.address': 'buildingLabel' | 'buildingPlaceholder' | 'changeBuildingAction' | 'description' | 'estateLabel' | 'floor.label' | 'floor.placeholder' | 'floorLevel.higher' | 'floorLevel.hint' | 'floorLevel.label' | 'floorLevel.lower' | 'floorLevel.middle' | 'loadingBuildings' | 'manualEntryLink' | 'manualHint' | 'manualLabel' | 'manualPlaceholder' | 'manualReviewNote' | 'noBuildingsHint' | 'noBuildingsTitle' | 'otherPhasesAction' | 'phaseLabel' | 'phasePlaceholder' | 'search.clear' | 'search.emptyAction' | 'search.emptyHint' | 'search.emptyTitle' | 'search.errorHint' | 'search.errorTitle' | 'search.hint' | 'search.loading' | 'search.multiPhase' | 'search.placeholder' | 'searchLink' | 'structureErrorHint' | 'structureErrorTitle' | 'title' | 'unit.label' | 'unit.placeholder';
  'wizard.address.floor': 'label' | 'placeholder';
  'wizard.address.floorLevel': 'higher' | 'hint' | 'label' | 'lower' | 'middle';
  'wizard.address.search': 'clear' | 'emptyAction' | 'emptyHint' | 'emptyTitle' | 'errorHint' | 'errorTitle' | 'hint' | 'loading' | 'multiPhase' | 'placeholder';
  'wizard.address.unit': 'label' | 'placeholder';
  'wizard.amenities': 'description' | 'title';
  'wizard.description': 'description' | 'hint' | 'label' | 'placeholder' | 'title';
  'wizard.errors': 'incomplete';
  'wizard.footer': 'back' | 'next' | 'publish';
  'wizard.media': 'add' | 'cover' | 'dropzone.subtitle' | 'photoAlt' | 'photosDone' | 'photosProgress' | 'rejected.tooLarge' | 'rejected.unsupportedType' | 'remove' | 'retry' | 'title' | 'uploadFailed';
  'wizard.media.dropzone': 'subtitle';
  'wizard.media.rejected': 'tooLarge' | 'unsupportedType';
  'wizard.payment': 'cancelled' | 'checkAgain' | 'confirming' | 'expired' | 'explainer' | 'paid' | 'payButton' | 'pendingHint' | 'publishButton' | 'publishIncomplete' | 'refunded' | 'startError' | 'statusError' | 'title';
  'wizard.pricing': 'description' | 'forRentLabel' | 'forSaleLabel' | 'rentPriceLabel' | 'rentPricePlaceholder' | 'salePriceLabel' | 'salePricePlaceholder' | 'title';
  'wizard.size': 'bathroomsLabel' | 'bedroomsLabel' | 'description' | 'pets.hint' | 'pets.label' | 'pets.unspecified' | 'propertyType.hint' | 'propertyType.label' | 'propertyType.options.detachedHouse' | 'propertyType.options.estateFlat' | 'propertyType.options.publicHousing' | 'propertyType.options.servicedApartment' | 'propertyType.options.singleBlockFlat' | 'propertyType.options.subsidisedHos' | 'propertyType.options.tongLau' | 'propertyType.options.villageHouse' | 'propertyType.options.walkUp' | 'roomsHint' | 'saleableAreaLabel' | 'saleableAreaPlaceholder' | 'studio' | 'title';
  'wizard.size.pets': 'hint' | 'label' | 'unspecified';
  'wizard.size.propertyType': 'hint' | 'label' | 'options.detachedHouse' | 'options.estateFlat' | 'options.publicHousing' | 'options.servicedApartment' | 'options.singleBlockFlat' | 'options.subsidisedHos' | 'options.tongLau' | 'options.villageHouse' | 'options.walkUp';
  'wizard.size.propertyType.options': 'detachedHouse' | 'estateFlat' | 'publicHousing' | 'servicedApartment' | 'singleBlockFlat' | 'subsidisedHos' | 'tongLau' | 'villageHouse' | 'walkUp';
  'wizard.toast': 'publishError' | 'publishSuccess';
}

/**
 * Every fully-qualified message key (the namespaceless `useTranslations()`
 * surface). This is what types the reason→catalog-key map + error fallback
 * keys, so a catalog key that does not exist is a COMPILE error.
 */
// prettier-ignore
export type AllMessageKeys =
  | 'about.contact.address'
  | 'about.contact.hoursTitle'
  | 'about.contact.title'
  | 'about.contact.weekdays'
  | 'about.contact.weekend'
  | 'about.description'
  | 'about.imageGrid.photoAlt.couple'
  | 'about.imageGrid.photoAlt.drawing'
  | 'about.imageGrid.photoAlt.hotpot'
  | 'about.imageGrid.photoAlt.mahjong'
  | 'about.imageGrid.photoAlt.takeaway'
  | 'about.imageGrid.photoAlt.team'
  | 'about.imageGrid.quote'
  | 'about.imageGrid.tagline'
  | 'about.seo.description'
  | 'about.seo.title'
  | 'about.team.bios.christal'
  | 'about.team.bios.xavier'
  | 'about.team.companyName'
  | 'about.team.roles.cofounder'
  | 'about.team.subtitle'
  | 'about.team.title'
  | 'about.title'
  | 'auth.google.button'
  | 'auth.google.errorBlocked'
  | 'auth.google.errorCancelled'
  | 'auth.google.errorPopupBlocked'
  | 'auth.google.errorSignIn'
  | 'auth.modal.or'
  | 'auth.modal.subtitle'
  | 'auth.modal.title'
  | 'auth.otp.back'
  | 'auth.otp.codeLabel'
  | 'auth.otp.codePlaceholder'
  | 'auth.otp.codeSentTo'
  | 'auth.otp.errorSend'
  | 'auth.otp.errorVerify'
  | 'auth.otp.phoneLabel'
  | 'auth.otp.phonePlaceholder'
  | 'auth.otp.privacyLink'
  | 'auth.otp.resend'
  | 'auth.otp.sendCode'
  | 'auth.otp.termsAnd'
  | 'auth.otp.termsLink'
  | 'auth.otp.termsText'
  | 'auth.otp.verify'
  | 'auth.shared.continueWithProvider'
  | 'blog.allCategories'
  | 'blog.byAuthor'
  | 'blog.categoriesLabel'
  | 'blog.categoryChip'
  | 'blog.clearSearch'
  | 'blog.listenToArticle'
  | 'blog.noPosts'
  | 'blog.noPostsForSearch'
  | 'blog.partnerRoleFallback'
  | 'blog.preview.description'
  | 'blog.preview.title'
  | 'blog.relatedPosts'
  | 'blog.searchLabel'
  | 'blog.searchPlaceholder'
  | 'blog.searchSubmit'
  | 'blog.tableOfContents'
  | 'blog.title'
  | 'common.a11y.backToHome'
  | 'common.a11y.breadcrumb'
  | 'common.a11y.carousel'
  | 'common.a11y.close'
  | 'common.a11y.listingSections'
  | 'common.a11y.mobileNavigation'
  | 'common.a11y.mute'
  | 'common.a11y.nextImage'
  | 'common.a11y.nextSlide'
  | 'common.a11y.officeLocation'
  | 'common.a11y.pause'
  | 'common.a11y.play'
  | 'common.a11y.previousImage'
  | 'common.a11y.previousSlide'
  | 'common.a11y.primaryNavigation'
  | 'common.a11y.seek'
  | 'common.a11y.selectCountry'
  | 'common.a11y.slide'
  | 'common.a11y.tableOfContents'
  | 'common.a11y.unmute'
  | 'common.a11y.viewAllImages'
  | 'common.a11y.wizardProgress'
  | 'common.loading'
  | 'common.retry'
  | 'contact.blurb'
  | 'contact.channel.body'
  | 'contact.channel.thread'
  | 'contact.channel.title'
  | 'contact.elsewhere.body'
  | 'contact.elsewhere.feedbackLink'
  | 'contact.elsewhere.helpLink'
  | 'contact.elsewhere.title'
  | 'contact.include.device'
  | 'contact.include.expected'
  | 'contact.include.intro'
  | 'contact.include.listing'
  | 'contact.include.title'
  | 'contact.include.when'
  | 'contact.logInAndChat'
  | 'contact.loginToContact'
  | 'contact.privacyHint'
  | 'contact.seo.description'
  | 'contact.seo.title'
  | 'contact.title'
  | 'contact.topics.account'
  | 'contact.topics.billing'
  | 'contact.topics.complaint'
  | 'contact.topics.general'
  | 'contact.topics.inquiry'
  | 'contact.topics.intro'
  | 'contact.topics.listing'
  | 'contact.topics.other'
  | 'contact.topics.technical'
  | 'contact.topics.title'
  | 'contact.typicalResponse'
  | 'conversations.composer.placeholder'
  | 'conversations.dayLabel.today'
  | 'conversations.dayLabel.yesterday'
  | 'conversations.empty.description'
  | 'conversations.empty.title'
  | 'conversations.message.showOriginal'
  | 'conversations.message.showTranslation'
  | 'conversations.message.translated'
  | 'conversations.preview_new_inquiry'
  | 'conversations.supportTitle'
  | 'conversations.systemEvent.awaitingSignature'
  | 'conversations.systemEvent.published'
  | 'conversations.systemEvent.relisted'
  | 'conversations.systemEvent.supportAutoClosed'
  | 'conversations.systemEvent.supportSeedPrompt'
  | 'conversations.systemEvent.unlisted'
  | 'conversations.title'
  | 'conversations.unknownParticipant'
  | 'conversations.you'
  | 'error.auth.alreadyLinked'
  | 'error.auth.codeRequired'
  | 'error.auth.emailInUse'
  | 'error.auth.emailNotVerified'
  | 'error.auth.googleSignInFailed'
  | 'error.auth.invalidCode'
  | 'error.auth.invalidInput'
  | 'error.auth.invalidPhone'
  | 'error.auth.invalidToken'
  | 'error.auth.lastProvider'
  | 'error.auth.notLinked'
  | 'error.auth.phoneInUse'
  | 'error.auth.phoneNumberRequired'
  | 'error.auth.rateLimited'
  | 'error.conversations.contentEmpty'
  | 'error.conversations.conversationIdRequired'
  | 'error.conversations.invalidInput'
  | 'error.conversations.messageBlockedExternalContact'
  | 'error.conversations.notParticipant'
  | 'error.conversations.unknownReadCursor'
  | 'error.feedbacks.emptyMessage'
  | 'error.generic'
  | 'error.leads.alreadyExists'
  | 'error.leads.invalidInput'
  | 'error.leads.listingNotLive'
  | 'error.leads.notFound'
  | 'error.leads.selfInquiry'
  | 'error.listings.alreadyExists'
  | 'error.listings.buildingNotFound'
  | 'error.listings.cannotPublishNonInProg'
  | 'error.listings.cannotRelistIncomplete'
  | 'error.listings.cannotRelistNonUnlisted'
  | 'error.listings.cannotUnlistNonListed'
  | 'error.listings.imageIdRequired'
  | 'error.listings.imageNotFound'
  | 'error.listings.invalidInput'
  | 'error.listings.listingNotFound'
  | 'error.listings.notOwner'
  | 'error.listings.wizardIncomplete'
  | 'error.payments.alreadyPaid'
  | 'error.payments.checkoutDisabled'
  | 'error.saved.alreadyExists'
  | 'error.saved.invalidInput'
  | 'error.saved.invalidSaveableId'
  | 'error.saved.notFound'
  | 'error.storefront.categoryNotFound'
  | 'error.storefront.districtNotFound'
  | 'error.storefront.estateNotFound'
  | 'error.storefront.listingNotFound'
  | 'error.storefront.partnerNotFound'
  | 'error.storefront.postNotFound'
  | 'error.support.invalidInput'
  | 'error.support.notFound'
  | 'estates.card.blocks'
  | 'estates.card.forRent'
  | 'estates.card.forSale'
  | 'estates.clearSearch'
  | 'estates.detail.buildings.forRent'
  | 'estates.detail.buildings.forSale'
  | 'estates.detail.buildingsCount'
  | 'estates.detail.census.attribution.dataGovHk'
  | 'estates.detail.census.attribution.terms'
  | 'estates.detail.census.dataSource'
  | 'estates.detail.census.female'
  | 'estates.detail.census.genderHeading'
  | 'estates.detail.census.heading'
  | 'estates.detail.census.male'
  | 'estates.detail.census.table.gender'
  | 'estates.detail.census.table.percentage'
  | 'estates.detail.census.table.population'
  | 'estates.detail.ctaButton'
  | 'estates.detail.ctaTitle'
  | 'estates.detail.facts.blocks'
  | 'estates.detail.facts.lift'
  | 'estates.detail.facts.no'
  | 'estates.detail.facts.phase'
  | 'estates.detail.facts.poi.carPark'
  | 'estates.detail.facts.poi.hospital'
  | 'estates.detail.facts.poi.mtr'
  | 'estates.detail.facts.poi.school'
  | 'estates.detail.facts.poi.value'
  | 'estates.detail.facts.title'
  | 'estates.detail.facts.type'
  | 'estates.detail.facts.village'
  | 'estates.detail.facts.yes'
  | 'estates.detail.faqs.title'
  | 'estates.detail.gallery.viewAll'
  | 'estates.detail.listingCount'
  | 'estates.detail.location'
  | 'estates.detail.nearMtr'
  | 'estates.detail.nearbyRentListings'
  | 'estates.detail.nearbySaleListings'
  | 'estates.detail.phases'
  | 'estates.detail.photoAlt'
  | 'estates.detail.priceTrend.disclaimer'
  | 'estates.detail.priceTrend.month'
  | 'estates.detail.priceTrend.rent'
  | 'estates.detail.priceTrend.sale'
  | 'estates.detail.priceTrend.samples'
  | 'estates.detail.priceTrend.title'
  | 'estates.detail.rentListings'
  | 'estates.detail.saleListings'
  | 'estates.detail.similar'
  | 'estates.districtFacet.about.buy'
  | 'estates.districtFacet.about.rent'
  | 'estates.districtFacet.aboutEmpty.buy'
  | 'estates.districtFacet.aboutEmpty.rent'
  | 'estates.districtFacet.aboutHeading'
  | 'estates.districtFacet.backToHub'
  | 'estates.districtFacet.buyLink'
  | 'estates.districtFacet.guidance.buy'
  | 'estates.districtFacet.guidance.rent'
  | 'estates.districtFacet.nearbyBuy'
  | 'estates.districtFacet.nearbyRent'
  | 'estates.districtFacet.population'
  | 'estates.districtFacet.rentLink'
  | 'estates.noEstates'
  | 'estates.noneForSearch'
  | 'estates.searchLabel'
  | 'estates.searchPlaceholder'
  | 'estates.searchSubmit'
  | 'estates.showing'
  | 'estates.subtitle'
  | 'estates.title'
  | 'feedback.backToHome'
  | 'feedback.contactSupport'
  | 'feedback.instead.body'
  | 'feedback.instead.title'
  | 'feedback.intro'
  | 'feedback.messageLabel'
  | 'feedback.messagePlaceholder'
  | 'feedback.needHelp'
  | 'feedback.seo.description'
  | 'feedback.seo.title'
  | 'feedback.signedIn'
  | 'feedback.submit'
  | 'feedback.submitError'
  | 'feedback.submitting'
  | 'feedback.thankYouMessage'
  | 'feedback.thankYouTitle'
  | 'feedback.title'
  | 'feedback.useful.broken'
  | 'feedback.useful.confusing'
  | 'feedback.useful.missing'
  | 'feedback.useful.title'
  | 'feedback.useful.working'
  | 'feedback.whatHappens.body'
  | 'feedback.whatHappens.title'
  | 'forms.disclaimer.paragraphs.0'
  | 'forms.disclaimer.paragraphs.1'
  | 'forms.disclaimer.paragraphs.2'
  | 'forms.disclaimer.title'
  | 'forms.documents.carParkLeaseAgreement.description'
  | 'forms.documents.carParkLeaseAgreement.file'
  | 'forms.documents.carParkLeaseAgreement.label'
  | 'forms.documents.completeRentalChecklist.description'
  | 'forms.documents.completeRentalChecklist.file'
  | 'forms.documents.completeRentalChecklist.label'
  | 'forms.documents.incomeProofSalaried.description'
  | 'forms.documents.incomeProofSalaried.file'
  | 'forms.documents.incomeProofSalaried.label'
  | 'forms.documents.incomeProofSelfEmployed.description'
  | 'forms.documents.incomeProofSelfEmployed.file'
  | 'forms.documents.incomeProofSelfEmployed.label'
  | 'forms.documents.provisionalTenancyAgreement.description'
  | 'forms.documents.provisionalTenancyAgreement.file'
  | 'forms.documents.provisionalTenancyAgreement.label'
  | 'forms.documents.surrenderAgreement.description'
  | 'forms.documents.surrenderAgreement.file'
  | 'forms.documents.surrenderAgreement.label'
  | 'forms.heading'
  | 'forms.seo.description'
  | 'forms.seo.title'
  | 'forms.title'
  | 'help.contactFeedback.contact.body'
  | 'help.contactFeedback.contact.button'
  | 'help.contactFeedback.contact.title'
  | 'help.contactFeedback.feedback.body'
  | 'help.contactFeedback.feedback.button'
  | 'help.contactFeedback.feedback.title'
  | 'help.greeting'
  | 'help.links.buyVsRent'
  | 'help.links.chineseConverter'
  | 'help.links.forms'
  | 'help.links.ratesGovernmentRent'
  | 'help.links.rentalYield'
  | 'help.links.schoolsAndRentals'
  | 'help.links.services'
  | 'help.links.stampDuty'
  | 'help.seo.description'
  | 'help.seo.title'
  | 'help.title'
  | 'home.faqs.heading'
  | 'home.faqs.items.hardSell.answer'
  | 'home.faqs.items.hardSell.question'
  | 'home.faqs.items.propertyTypes.answer'
  | 'home.faqs.items.propertyTypes.question'
  | 'home.faqs.items.whatIsLgh.answer'
  | 'home.faqs.items.whatIsLgh.question'
  | 'home.hero.searchExamples.0'
  | 'home.hero.searchExamples.1'
  | 'home.hero.searchExamples.2'
  | 'home.hero.searchExamples.3'
  | 'home.hero.searchExamples.4'
  | 'home.hero.title'
  | 'home.tips.title'
  | 'home.whyUs.cta'
  | 'home.whyUs.heading'
  | 'home.whyUs.serveNotSell.description'
  | 'home.whyUs.serveNotSell.heading'
  | 'home.whyUs.valueForMoney.description'
  | 'home.whyUs.valueForMoney.heading'
  | 'home.whyUs.videoAlt'
  | 'inquiry.budgetPlaceholder'
  | 'inquiry.errors.failed'
  | 'inquiry.errors.messageRequired'
  | 'inquiry.intentBuy'
  | 'inquiry.intentLabel'
  | 'inquiry.intentRent'
  | 'inquiry.leaseTerm'
  | 'inquiry.leaseTermPlaceholder'
  | 'inquiry.maxBudget'
  | 'inquiry.messageLabel'
  | 'inquiry.messagePlaceholder'
  | 'inquiry.moveInDate'
  | 'inquiry.occupantsCount'
  | 'inquiry.occupantsPlaceholder'
  | 'inquiry.perMonth'
  | 'inquiry.purchaseTimeframe'
  | 'inquiry.sending'
  | 'inquiry.submit'
  | 'inquiry.success'
  | 'inquiry.timeframeHint'
  | 'inquiry.timeframePlaceholder'
  | 'inquiry.title'
  | 'legal.privacyPolicy.afterDeletion'
  | 'legal.privacyPolicy.afterDeletionTitle'
  | 'legal.privacyPolicy.changesToPolicy'
  | 'legal.privacyPolicy.changesToPolicyTitle'
  | 'legal.privacyPolicy.contactUs'
  | 'legal.privacyPolicy.contactUsTitle'
  | 'legal.privacyPolicy.cookiePolicyTitle'
  | 'legal.privacyPolicy.exceptions'
  | 'legal.privacyPolicy.exceptionsTitle'
  | 'legal.privacyPolicy.howWeShare'
  | 'legal.privacyPolicy.howWeShareTitle'
  | 'legal.privacyPolicy.howWeUse'
  | 'legal.privacyPolicy.howWeUseTitle'
  | 'legal.privacyPolicy.informationWeCollect'
  | 'legal.privacyPolicy.informationWeCollectTitle'
  | 'legal.privacyPolicy.introduction'
  | 'legal.privacyPolicy.introductionTitle'
  | 'legal.privacyPolicy.lastUpdated'
  | 'legal.privacyPolicy.personalInformation.description'
  | 'legal.privacyPolicy.personalInformation.label'
  | 'legal.privacyPolicy.propertyInformation.description'
  | 'legal.privacyPolicy.propertyInformation.label'
  | 'legal.privacyPolicy.security'
  | 'legal.privacyPolicy.securityTitle'
  | 'legal.privacyPolicy.seo.description'
  | 'legal.privacyPolicy.seo.title'
  | 'legal.privacyPolicy.siteProtection.label'
  | 'legal.privacyPolicy.title'
  | 'legal.privacyPolicy.usages.facilitateTransactions'
  | 'legal.privacyPolicy.usages.improveWebsite'
  | 'legal.privacyPolicy.usages.respondToInquiries'
  | 'legal.privacyPolicy.yourRights'
  | 'legal.privacyPolicy.yourRightsTitle'
  | 'legal.termsOfService.accountRegistration'
  | 'legal.termsOfService.accountRegistrationTitle'
  | 'legal.termsOfService.changesToTerms'
  | 'legal.termsOfService.changesToTermsTitle'
  | 'legal.termsOfService.contactUs'
  | 'legal.termsOfService.contactUsTitle'
  | 'legal.termsOfService.content'
  | 'legal.termsOfService.contentTitle'
  | 'legal.termsOfService.disclaimer'
  | 'legal.termsOfService.disclaimerTitle'
  | 'legal.termsOfService.eligibility'
  | 'legal.termsOfService.eligibilityTitle'
  | 'legal.termsOfService.governingLaw'
  | 'legal.termsOfService.governingLawTitle'
  | 'legal.termsOfService.introduction'
  | 'legal.termsOfService.introductionTitle'
  | 'legal.termsOfService.lastUpdated'
  | 'legal.termsOfService.limitationOfLiability'
  | 'legal.termsOfService.limitationOfLiabilityTitle'
  | 'legal.termsOfService.seo.description'
  | 'legal.termsOfService.seo.title'
  | 'legal.termsOfService.title'
  | 'legal.termsOfService.userObligations'
  | 'legal.termsOfService.userObligationsTitle'
  | 'listings.browse.failedToLoad'
  | 'listings.browse.failedToLoadShort'
  | 'listings.browse.map'
  | 'listings.browse.noListings'
  | 'listings.browse.noListingsShort'
  | 'listings.browse.propertyCount'
  | 'listings.browse.propertyListings'
  | 'listings.card.bathrooms'
  | 'listings.card.bedrooms'
  | 'listings.card.bedroomsStudio'
  | 'listings.card.noImage'
  | 'listings.card.perMonth'
  | 'listings.card.save'
  | 'listings.card.saved'
  | 'listings.card.sqft'
  | 'listings.card.statusAwaitingSignature'
  | 'listings.card.statusDeleted'
  | 'listings.card.statusInProgress'
  | 'listings.card.statusListed'
  | 'listings.card.statusPublishing'
  | 'listings.card.statusUnlisted'
  | 'listings.carousel.forRent'
  | 'listings.carousel.forSale'
  | 'listings.dashboard.createButton'
  | 'listings.dashboard.empty.cta'
  | 'listings.dashboard.empty.description'
  | 'listings.dashboard.empty.title'
  | 'listings.dashboard.title'
  | 'listings.detail.about.title'
  | 'listings.detail.amenities'
  | 'listings.detail.bathrooms'
  | 'listings.detail.bathroomsLabel'
  | 'listings.detail.bedrooms'
  | 'listings.detail.bedroomsLabel'
  | 'listings.detail.continueConversation'
  | 'listings.detail.description'
  | 'listings.detail.floorLabel'
  | 'listings.detail.forRent'
  | 'listings.detail.forSale'
  | 'listings.detail.interestedSubtitle'
  | 'listings.detail.interestedTitle'
  | 'listings.detail.listerSubtitle'
  | 'listings.detail.location'
  | 'listings.detail.manageListing'
  | 'listings.detail.messageLister'
  | 'listings.detail.notAvailable'
  | 'listings.detail.originalNotice'
  | 'listings.detail.perMonth'
  | 'listings.detail.petsAllowed'
  | 'listings.detail.petsLabel'
  | 'listings.detail.petsNotAllowed'
  | 'listings.detail.propertyInfo'
  | 'listings.detail.ref'
  | 'listings.detail.showOriginal'
  | 'listings.detail.showTranslation'
  | 'listings.detail.sizeLabel'
  | 'listings.detail.sqft'
  | 'listings.detail.studio'
  | 'listings.detail.translatedNotice'
  | 'listings.detail.unknownLocation'
  | 'listings.editor.actions.view'
  | 'listings.editor.morePhotos'
  | 'listings.editor.noPhotos'
  | 'listings.editor.sections.address'
  | 'listings.editor.sections.amenities'
  | 'listings.editor.sections.description'
  | 'listings.editor.sections.media'
  | 'listings.editor.sections.pricing'
  | 'listings.editor.sections.size'
  | 'listings.editor.title'
  | 'listings.editor.untitled'
  | 'listings.filters.any'
  | 'listings.filters.apply'
  | 'listings.filters.bathrooms'
  | 'listings.filters.bedrooms'
  | 'listings.filters.buttonLabel'
  | 'listings.filters.buttonLabelWithCount'
  | 'listings.filters.petsAllowed'
  | 'listings.filters.priceRange'
  | 'listings.filters.reset'
  | 'listings.filters.rooms'
  | 'listings.filters.showResults'
  | 'listings.filters.title'
  | 'listings.gallery.morePhotos'
  | 'listings.gallery.noImages'
  | 'listings.gallery.title'
  | 'listings.gallery.viewAll'
  | 'listings.new.cta'
  | 'listings.new.ctaSubtext'
  | 'listings.new.steps.0.subtitle'
  | 'listings.new.steps.0.title'
  | 'listings.new.steps.1.subtitle'
  | 'listings.new.steps.1.title'
  | 'listings.new.steps.2.subtitle'
  | 'listings.new.steps.2.title'
  | 'listings.new.title'
  | 'listings.searchClose'
  | 'listings.searchLocation'
  | 'listings.sort.label'
  | 'listings.sort.newest'
  | 'listings.sort.priceAsc'
  | 'listings.sort.priceDesc'
  | 'listings.typeFacet.backToBuy'
  | 'listings.typeFacet.backToRent'
  | 'market.attribution.heading'
  | 'market.attribution.terms'
  | 'market.empty'
  | 'market.month'
  | 'market.provisionalHint'
  | 'market.provisionalMark'
  | 'market.sourceLine'
  | 'market.subtitle'
  | 'max'
  | 'messages.signed.out.help'
  | 'messages.signed.out.intro'
  | 'min'
  | 'nav.account.dashboard'
  | 'nav.account.helpCenter'
  | 'nav.account.listProperty'
  | 'nav.account.listings'
  | 'nav.account.loginOrSignUp'
  | 'nav.account.messages'
  | 'nav.account.saved'
  | 'nav.account.settings'
  | 'nav.account.signOut'
  | 'nav.buy'
  | 'nav.explore'
  | 'nav.footer.companyName'
  | 'nav.footer.groups.company'
  | 'nav.footer.groups.explore'
  | 'nav.footer.groups.support'
  | 'nav.footer.legal.privacy'
  | 'nav.footer.legal.terms'
  | 'nav.footer.links.aboutUs'
  | 'nav.footer.links.blog'
  | 'nav.footer.links.buyProperty'
  | 'nav.footer.links.contactSupport'
  | 'nav.footer.links.districts'
  | 'nav.footer.links.estates'
  | 'nav.footer.links.giveFeedback'
  | 'nav.footer.links.helpCenter'
  | 'nav.footer.links.market'
  | 'nav.footer.links.partners'
  | 'nav.footer.links.rentProperty'
  | 'nav.footer.links.services'
  | 'nav.footer.links.tools'
  | 'nav.footer.links.transactions'
  | 'nav.footer.visitOn'
  | 'nav.language'
  | 'nav.messages'
  | 'nav.profile'
  | 'nav.rent'
  | 'nav.saved'
  | 'pageTitles.address'
  | 'pageTitles.amenities'
  | 'pageTitles.conversation'
  | 'pageTitles.description'
  | 'pageTitles.inquiry'
  | 'pageTitles.listingEditor'
  | 'pageTitles.messages'
  | 'pageTitles.myListings'
  | 'pageTitles.newListing'
  | 'pageTitles.payment'
  | 'pageTitles.photos'
  | 'pageTitles.postPreview'
  | 'pageTitles.pricing'
  | 'pageTitles.profile'
  | 'pageTitles.saved'
  | 'pageTitles.settings'
  | 'pageTitles.sizeLayout'
  | 'pager.gotoPage'
  | 'pager.label'
  | 'pager.next'
  | 'pager.pageOf'
  | 'pager.previous'
  | 'partners.about.body'
  | 'partners.about.title'
  | 'partners.directory.count'
  | 'partners.directory.how.body'
  | 'partners.directory.how.title'
  | 'partners.directory.roles'
  | 'partners.howToJoin.body'
  | 'partners.howToJoin.cta'
  | 'partners.howToJoin.title'
  | 'partners.noPartners'
  | 'partners.noPostsYet'
  | 'partners.postsByPartner'
  | 'partners.readGuides.body'
  | 'partners.readGuides.cta'
  | 'partners.readGuides.title'
  | 'partners.subtitle'
  | 'partners.title'
  | 'partners.visitWebsite'
  | 'pets.policy.allowed'
  | 'pets.policy.not_allowed'
  | 'preferences.autoTranslate.description'
  | 'preferences.autoTranslate.label'
  | 'preferences.currency.label'
  | 'preferences.currency.options.cny'
  | 'preferences.currency.options.hkd'
  | 'preferences.language.label'
  | 'preferences.title'
  | 'preferences.unitSystem.label'
  | 'preferences.unitSystem.options.imperial'
  | 'preferences.unitSystem.options.metric'
  | 'profile.list.property.description'
  | 'profile.list.property.title'
  | 'profile.signed.out.intro'
  | 'profile.title'
  | 'saved.empty.cta'
  | 'saved.empty.description'
  | 'saved.empty.title'
  | 'saved.signed.out.help'
  | 'saved.signed.out.intro'
  | 'saved.subtitle'
  | 'saved.title'
  | 'saved.unavailable'
  | 'schoolsAndRentals.dataAccuracy.details'
  | 'schoolsAndRentals.dataAccuracy.title'
  | 'schoolsAndRentals.disclaimerSection.details'
  | 'schoolsAndRentals.disclaimerSection.title'
  | 'schoolsAndRentals.faqs.list.0.answer'
  | 'schoolsAndRentals.faqs.list.0.question'
  | 'schoolsAndRentals.faqs.list.1.answer'
  | 'schoolsAndRentals.faqs.list.1.question'
  | 'schoolsAndRentals.faqs.list.2.answer'
  | 'schoolsAndRentals.faqs.list.2.question'
  | 'schoolsAndRentals.faqs.list.3.answer'
  | 'schoolsAndRentals.faqs.list.3.question'
  | 'schoolsAndRentals.faqs.list.4.answer'
  | 'schoolsAndRentals.faqs.list.4.question'
  | 'schoolsAndRentals.faqs.title'
  | 'schoolsAndRentals.pageTitle'
  | 'schoolsAndRentals.peaceOfMind.details'
  | 'schoolsAndRentals.peaceOfMind.title'
  | 'schoolsAndRentals.rentalListings.details'
  | 'schoolsAndRentals.rentalListings.title'
  | 'schoolsAndRentals.seo.description'
  | 'schoolsAndRentals.seo.title'
  | 'schoolsAndRentals.subtitle'
  | 'schoolsAndRentals.title'
  | 'schoolsAndRentals.whyChoose.details.0'
  | 'schoolsAndRentals.whyChoose.details.1'
  | 'schoolsAndRentals.whyChoose.details.2'
  | 'schoolsAndRentals.whyChoose.title'
  | 'search.clear'
  | 'search.placeholder'
  | 'search.rentCount'
  | 'search.saleCount'
  | 'search.sections.buildings'
  | 'search.sections.districts'
  | 'search.sections.estates'
  | 'search.submit'
  | 'search.suggestions.emptyHint'
  | 'search.suggestions.emptyTitle'
  | 'search.suggestions.errorHint'
  | 'search.suggestions.errorTitle'
  | 'search.suggestions.loading'
  | 'services.buyRent.assisted.features.0'
  | 'services.buyRent.assisted.features.1'
  | 'services.buyRent.assisted.features.2'
  | 'services.buyRent.assisted.title'
  | 'services.buyRent.cta'
  | 'services.buyRent.self.features.0'
  | 'services.buyRent.self.features.1'
  | 'services.buyRent.self.features.2'
  | 'services.buyRent.self.title'
  | 'services.buyRent.subtitle'
  | 'services.buyRent.title'
  | 'services.closing'
  | 'services.faqs.list.0.answer'
  | 'services.faqs.list.0.question'
  | 'services.faqs.list.1.answer'
  | 'services.faqs.list.1.question'
  | 'services.faqs.list.2.answer'
  | 'services.faqs.list.2.question'
  | 'services.faqs.list.3.answer'
  | 'services.faqs.list.3.question'
  | 'services.faqs.title'
  | 'services.learnMore'
  | 'services.scrollToExplore'
  | 'services.sellLease.assisted.features.0'
  | 'services.sellLease.assisted.features.1'
  | 'services.sellLease.assisted.features.2'
  | 'services.sellLease.assisted.title'
  | 'services.sellLease.cta'
  | 'services.sellLease.self.features.0'
  | 'services.sellLease.self.features.1'
  | 'services.sellLease.self.features.2'
  | 'services.sellLease.self.title'
  | 'services.sellLease.subtitle'
  | 'services.sellLease.title'
  | 'services.seo.description'
  | 'services.seo.title'
  | 'services.socialProof.testimonials.0.name'
  | 'services.socialProof.testimonials.0.text'
  | 'services.socialProof.testimonials.1.name'
  | 'services.socialProof.testimonials.1.text'
  | 'services.socialProof.testimonials.2.name'
  | 'services.socialProof.testimonials.2.text'
  | 'services.socialProof.testimonials.3.name'
  | 'services.socialProof.testimonials.3.text'
  | 'services.socialProof.testimonials.4.name'
  | 'services.socialProof.testimonials.4.text'
  | 'services.socialProof.title'
  | 'services.subtitle'
  | 'services.tabs.assisted'
  | 'services.tabs.self'
  | 'services.title'
  | 'settings.autoTranslate.hint'
  | 'settings.autoTranslate.label'
  | 'settings.autoTranslate.title'
  | 'settings.first_name.label'
  | 'settings.first_name.placeholder'
  | 'settings.last_name.label'
  | 'settings.last_name.placeholder'
  | 'settings.not_set'
  | 'settings.notifications.email.subtitle'
  | 'settings.notifications.email.title'
  | 'settings.notifications.push.subtitle'
  | 'settings.notifications.push.title'
  | 'settings.notifications.sms.subtitle'
  | 'settings.notifications.sms.title'
  | 'settings.notifications.title'
  | 'settings.notifications.whatsapp.subtitle'
  | 'settings.notifications.whatsapp.title'
  | 'settings.personal.info'
  | 'settings.phone.change.hint'
  | 'settings.phone.number'
  | 'settings.save'
  | 'settings.save_error'
  | 'settings.saved'
  | 'settings.title'
  | 'support.blurb'
  | 'support.category.account'
  | 'support.category.billing'
  | 'support.category.complaint'
  | 'support.category.general'
  | 'support.category.inquiry'
  | 'support.category.label'
  | 'support.category.listing'
  | 'support.category.other'
  | 'support.category.technical'
  | 'support.errors.failed'
  | 'support.message.hint'
  | 'support.message.label'
  | 'support.message.placeholder'
  | 'support.seo.description'
  | 'support.seo.title'
  | 'support.submit'
  | 'support.title'
  | 'tools.affordability.advantages.points.0'
  | 'tools.affordability.advantages.points.1'
  | 'tools.affordability.advantages.points.2'
  | 'tools.affordability.advantages.points.3'
  | 'tools.affordability.advantages.title'
  | 'tools.affordability.calculate'
  | 'tools.affordability.calculator.notice'
  | 'tools.affordability.calculator.title'
  | 'tools.affordability.deposit'
  | 'tools.affordability.explainer.blocks.0.body'
  | 'tools.affordability.explainer.blocks.0.heading'
  | 'tools.affordability.explainer.blocks.1.body'
  | 'tools.affordability.explainer.blocks.1.heading'
  | 'tools.affordability.explainer.blocks.2.body'
  | 'tools.affordability.explainer.blocks.2.heading'
  | 'tools.affordability.explainer.blocks.3.body'
  | 'tools.affordability.explainer.blocks.3.heading'
  | 'tools.affordability.explainer.title'
  | 'tools.affordability.faqs.list.0.answer'
  | 'tools.affordability.faqs.list.0.question'
  | 'tools.affordability.faqs.list.1.answer'
  | 'tools.affordability.faqs.list.1.question'
  | 'tools.affordability.faqs.list.2.answer'
  | 'tools.affordability.faqs.list.2.question'
  | 'tools.affordability.faqs.list.3.answer'
  | 'tools.affordability.faqs.list.3.question'
  | 'tools.affordability.faqs.list.4.answer'
  | 'tools.affordability.faqs.list.4.question'
  | 'tools.affordability.faqs.list.5.answer'
  | 'tools.affordability.faqs.list.5.question'
  | 'tools.affordability.faqs.title'
  | 'tools.affordability.howToUse.steps.0'
  | 'tools.affordability.howToUse.steps.1'
  | 'tools.affordability.howToUse.steps.2'
  | 'tools.affordability.howToUse.steps.3'
  | 'tools.affordability.howToUse.title'
  | 'tools.affordability.interestRate'
  | 'tools.affordability.monthlyIncome'
  | 'tools.affordability.pageTitle'
  | 'tools.affordability.related.buyVsRent'
  | 'tools.affordability.related.mortgage'
  | 'tools.affordability.related.ratesGovernmentRent'
  | 'tools.affordability.related.stampDuty'
  | 'tools.affordability.related.title'
  | 'tools.affordability.results.boundByDeposit'
  | 'tools.affordability.results.boundByIncome'
  | 'tools.affordability.results.maxLoan'
  | 'tools.affordability.results.maxPropertyPrice'
  | 'tools.affordability.results.monthlyPayment'
  | 'tools.affordability.seo.description'
  | 'tools.affordability.seo.title'
  | 'tools.affordability.subtitle'
  | 'tools.affordability.termYears'
  | 'tools.buyVsRent.analysisTool.buyingCost.title'
  | 'tools.buyVsRent.analysisTool.calculate'
  | 'tools.buyVsRent.analysisTool.rentingCost.title'
  | 'tools.buyVsRent.analysisTool.title'
  | 'tools.buyVsRent.breakevenMessage'
  | 'tools.buyVsRent.buyOrRent.own'
  | 'tools.buyVsRent.buyOrRent.ownOrRent'
  | 'tools.buyVsRent.buyOrRent.rent'
  | 'tools.buyVsRent.buyOrRent.title'
  | 'tools.buyVsRent.buyOrRent.totalBuyingCost'
  | 'tools.buyVsRent.buyOrRent.totalRentingCost'
  | 'tools.buyVsRent.conclusion'
  | 'tools.buyVsRent.disclaimer.details'
  | 'tools.buyVsRent.disclaimer.title'
  | 'tools.buyVsRent.fields.downPayment'
  | 'tools.buyVsRent.fields.governmentRates'
  | 'tools.buyVsRent.fields.governmentRent'
  | 'tools.buyVsRent.fields.homeInsurance'
  | 'tools.buyVsRent.fields.maintenanceFees'
  | 'tools.buyVsRent.fields.mortgagePayment'
  | 'tools.buyVsRent.fields.mortgageTermYears'
  | 'tools.buyVsRent.fields.propertyPrice'
  | 'tools.buyVsRent.fields.rent'
  | 'tools.buyVsRent.fields.rentDurationYears'
  | 'tools.buyVsRent.fields.rentIncreaseRate'
  | 'tools.buyVsRent.howToUse.intro'
  | 'tools.buyVsRent.howToUse.title'
  | 'tools.buyVsRent.makeDecisionSmart.intro'
  | 'tools.buyVsRent.makeDecisionSmart.title'
  | 'tools.buyVsRent.needMoreAssistance.details'
  | 'tools.buyVsRent.needMoreAssistance.title'
  | 'tools.buyVsRent.pageTitle'
  | 'tools.buyVsRent.readyToExplore.details'
  | 'tools.buyVsRent.readyToExplore.title'
  | 'tools.buyVsRent.seo.description'
  | 'tools.buyVsRent.seo.title'
  | 'tools.buyVsRent.subtitle'
  | 'tools.chineseConverter.advantages.point1'
  | 'tools.chineseConverter.advantages.point2'
  | 'tools.chineseConverter.advantages.point3'
  | 'tools.chineseConverter.advantages.point4'
  | 'tools.chineseConverter.advantages.title'
  | 'tools.chineseConverter.callToAction'
  | 'tools.chineseConverter.converter.copy'
  | 'tools.chineseConverter.converter.fieldLabel'
  | 'tools.chineseConverter.converter.input'
  | 'tools.chineseConverter.converter.inputPlaceholder'
  | 'tools.chineseConverter.converter.output'
  | 'tools.chineseConverter.converter.outputPlaceholder'
  | 'tools.chineseConverter.converter.simplified'
  | 'tools.chineseConverter.converter.submitButton'
  | 'tools.chineseConverter.converter.title'
  | 'tools.chineseConverter.converter.toSimplified'
  | 'tools.chineseConverter.converter.toTraditional'
  | 'tools.chineseConverter.converter.traditional'
  | 'tools.chineseConverter.footerNote.p1'
  | 'tools.chineseConverter.footerNote.p2'
  | 'tools.chineseConverter.howToUse.step1'
  | 'tools.chineseConverter.howToUse.step2'
  | 'tools.chineseConverter.howToUse.step3'
  | 'tools.chineseConverter.howToUse.step4'
  | 'tools.chineseConverter.howToUse.title'
  | 'tools.chineseConverter.pageTitle'
  | 'tools.chineseConverter.seo.description'
  | 'tools.chineseConverter.seo.title'
  | 'tools.chineseConverter.subtitle'
  | 'tools.index.affordability.description'
  | 'tools.index.affordability.title'
  | 'tools.index.buyVsRent.description'
  | 'tools.index.buyVsRent.title'
  | 'tools.index.calculators.title'
  | 'tools.index.chineseConverter.description'
  | 'tools.index.chineseConverter.title'
  | 'tools.index.cta.button'
  | 'tools.index.cta.description'
  | 'tools.index.cta.title'
  | 'tools.index.mortgage.description'
  | 'tools.index.mortgage.title'
  | 'tools.index.pageTitle'
  | 'tools.index.ratesRent.description'
  | 'tools.index.ratesRent.title'
  | 'tools.index.rentalYield.description'
  | 'tools.index.rentalYield.title'
  | 'tools.index.seo.description'
  | 'tools.index.seo.title'
  | 'tools.index.stampDuty.description'
  | 'tools.index.stampDuty.title'
  | 'tools.index.subtitle'
  | 'tools.index.templates.carPark.description'
  | 'tools.index.templates.carPark.title'
  | 'tools.index.templates.download'
  | 'tools.index.templates.incomeProofSalaried.description'
  | 'tools.index.templates.incomeProofSalaried.title'
  | 'tools.index.templates.incomeProofSelf.description'
  | 'tools.index.templates.incomeProofSelf.title'
  | 'tools.index.templates.rentalChecklist.description'
  | 'tools.index.templates.rentalChecklist.title'
  | 'tools.index.templates.subtitle'
  | 'tools.index.templates.surrenderAgreement.description'
  | 'tools.index.templates.surrenderAgreement.title'
  | 'tools.index.templates.tenancyAgreement.description'
  | 'tools.index.templates.tenancyAgreement.title'
  | 'tools.index.templates.title'
  | 'tools.mortgage.advantages.points.0'
  | 'tools.mortgage.advantages.points.1'
  | 'tools.mortgage.advantages.points.2'
  | 'tools.mortgage.advantages.points.3'
  | 'tools.mortgage.advantages.points.4'
  | 'tools.mortgage.advantages.title'
  | 'tools.mortgage.calculate'
  | 'tools.mortgage.calculator.notice'
  | 'tools.mortgage.calculator.title'
  | 'tools.mortgage.downPaymentPct'
  | 'tools.mortgage.explainer.blocks.0.body'
  | 'tools.mortgage.explainer.blocks.0.heading'
  | 'tools.mortgage.explainer.blocks.1.body'
  | 'tools.mortgage.explainer.blocks.1.heading'
  | 'tools.mortgage.explainer.blocks.2.body'
  | 'tools.mortgage.explainer.blocks.2.heading'
  | 'tools.mortgage.explainer.blocks.3.body'
  | 'tools.mortgage.explainer.blocks.3.heading'
  | 'tools.mortgage.explainer.blocks.4.body'
  | 'tools.mortgage.explainer.blocks.4.heading'
  | 'tools.mortgage.explainer.blocks.5.body'
  | 'tools.mortgage.explainer.blocks.5.heading'
  | 'tools.mortgage.explainer.blocks.6.body'
  | 'tools.mortgage.explainer.blocks.6.heading'
  | 'tools.mortgage.explainer.title'
  | 'tools.mortgage.faqs.list.0.answer'
  | 'tools.mortgage.faqs.list.0.question'
  | 'tools.mortgage.faqs.list.1.answer'
  | 'tools.mortgage.faqs.list.1.question'
  | 'tools.mortgage.faqs.list.2.answer'
  | 'tools.mortgage.faqs.list.2.question'
  | 'tools.mortgage.faqs.list.3.answer'
  | 'tools.mortgage.faqs.list.3.question'
  | 'tools.mortgage.faqs.list.4.answer'
  | 'tools.mortgage.faqs.list.4.question'
  | 'tools.mortgage.faqs.list.5.answer'
  | 'tools.mortgage.faqs.list.5.question'
  | 'tools.mortgage.faqs.list.6.answer'
  | 'tools.mortgage.faqs.list.6.question'
  | 'tools.mortgage.faqs.list.7.answer'
  | 'tools.mortgage.faqs.list.7.question'
  | 'tools.mortgage.faqs.title'
  | 'tools.mortgage.howToUse.steps.0'
  | 'tools.mortgage.howToUse.steps.1'
  | 'tools.mortgage.howToUse.steps.2'
  | 'tools.mortgage.howToUse.steps.3'
  | 'tools.mortgage.howToUse.title'
  | 'tools.mortgage.interestRate'
  | 'tools.mortgage.pageTitle'
  | 'tools.mortgage.propertyPrice'
  | 'tools.mortgage.related.affordability'
  | 'tools.mortgage.related.buyVsRent'
  | 'tools.mortgage.related.ratesGovernmentRent'
  | 'tools.mortgage.related.stampDuty'
  | 'tools.mortgage.related.title'
  | 'tools.mortgage.results.loanAmount'
  | 'tools.mortgage.results.monthlyPayment'
  | 'tools.mortgage.results.stressPayment'
  | 'tools.mortgage.results.totalInterest'
  | 'tools.mortgage.results.totalRepayment'
  | 'tools.mortgage.seo.description'
  | 'tools.mortgage.seo.title'
  | 'tools.mortgage.subtitle'
  | 'tools.mortgage.termYears'
  | 'tools.ratesGovernmentRent.calculation.rateableValue.description'
  | 'tools.ratesGovernmentRent.calculation.rateableValue.title'
  | 'tools.ratesGovernmentRent.calculation.rates.collectionRate'
  | 'tools.ratesGovernmentRent.calculation.rates.firstThreeQuarters'
  | 'tools.ratesGovernmentRent.calculation.rates.fourthQuarter'
  | 'tools.ratesGovernmentRent.calculation.rates.fourthQuarterStep1'
  | 'tools.ratesGovernmentRent.calculation.rates.fourthQuarterStep2'
  | 'tools.ratesGovernmentRent.calculation.rates.fourthQuarterStep3'
  | 'tools.ratesGovernmentRent.calculation.rates.nonResidential'
  | 'tools.ratesGovernmentRent.calculation.rates.rateableValueOver'
  | 'tools.ratesGovernmentRent.calculation.rates.rateableValueUpTo'
  | 'tools.ratesGovernmentRent.calculation.rates.residentialRates'
  | 'tools.ratesGovernmentRent.calculation.rates.title'
  | 'tools.ratesGovernmentRent.calculation.reductions.description'
  | 'tools.ratesGovernmentRent.calculation.reductions.title'
  | 'tools.ratesGovernmentRent.calculation.title'
  | 'tools.ratesGovernmentRent.calculator.assessmentYear'
  | 'tools.ratesGovernmentRent.calculator.calculate'
  | 'tools.ratesGovernmentRent.calculator.nonResidential'
  | 'tools.ratesGovernmentRent.calculator.propertyType'
  | 'tools.ratesGovernmentRent.calculator.residential'
  | 'tools.ratesGovernmentRent.calculator.title'
  | 'tools.ratesGovernmentRent.calculator.totalQuarter1'
  | 'tools.ratesGovernmentRent.calculator.totalQuarter2'
  | 'tools.ratesGovernmentRent.calculator.totalQuarter3'
  | 'tools.ratesGovernmentRent.calculator.totalQuarter4'
  | 'tools.ratesGovernmentRent.disclaimer.description'
  | 'tools.ratesGovernmentRent.disclaimer.title'
  | 'tools.ratesGovernmentRent.exemptions.category1'
  | 'tools.ratesGovernmentRent.exemptions.category2'
  | 'tools.ratesGovernmentRent.exemptions.category3'
  | 'tools.ratesGovernmentRent.exemptions.category4'
  | 'tools.ratesGovernmentRent.exemptions.category5'
  | 'tools.ratesGovernmentRent.exemptions.category6'
  | 'tools.ratesGovernmentRent.exemptions.conclusion'
  | 'tools.ratesGovernmentRent.exemptions.intro'
  | 'tools.ratesGovernmentRent.exemptions.title'
  | 'tools.ratesGovernmentRent.fields.rateableValue'
  | 'tools.ratesGovernmentRent.howToUse.step1'
  | 'tools.ratesGovernmentRent.howToUse.step2'
  | 'tools.ratesGovernmentRent.howToUse.step3'
  | 'tools.ratesGovernmentRent.howToUse.title'
  | 'tools.ratesGovernmentRent.pageTitle'
  | 'tools.ratesGovernmentRent.result.rates'
  | 'tools.ratesGovernmentRent.result.reduction'
  | 'tools.ratesGovernmentRent.result.rent'
  | 'tools.ratesGovernmentRent.schedule.header1'
  | 'tools.ratesGovernmentRent.schedule.header2'
  | 'tools.ratesGovernmentRent.schedule.header3'
  | 'tools.ratesGovernmentRent.schedule.rows.q1.delivery'
  | 'tools.ratesGovernmentRent.schedule.rows.q1.payment'
  | 'tools.ratesGovernmentRent.schedule.rows.q1.quarter'
  | 'tools.ratesGovernmentRent.schedule.rows.q2.delivery'
  | 'tools.ratesGovernmentRent.schedule.rows.q2.payment'
  | 'tools.ratesGovernmentRent.schedule.rows.q2.quarter'
  | 'tools.ratesGovernmentRent.schedule.rows.q3.delivery'
  | 'tools.ratesGovernmentRent.schedule.rows.q3.payment'
  | 'tools.ratesGovernmentRent.schedule.rows.q3.quarter'
  | 'tools.ratesGovernmentRent.schedule.rows.q4.delivery'
  | 'tools.ratesGovernmentRent.schedule.rows.q4.payment'
  | 'tools.ratesGovernmentRent.schedule.rows.q4.quarter'
  | 'tools.ratesGovernmentRent.schedule.title'
  | 'tools.ratesGovernmentRent.seo.description'
  | 'tools.ratesGovernmentRent.seo.title'
  | 'tools.ratesGovernmentRent.subtitle'
  | 'tools.ratesGovernmentRent.title'
  | 'tools.ratesGovernmentRent.whyUse.step1'
  | 'tools.ratesGovernmentRent.whyUse.step2'
  | 'tools.ratesGovernmentRent.whyUse.step3'
  | 'tools.ratesGovernmentRent.whyUse.step4'
  | 'tools.ratesGovernmentRent.whyUse.step5'
  | 'tools.ratesGovernmentRent.whyUse.title'
  | 'tools.rentalYield.calculator.annualReturn'
  | 'tools.rentalYield.calculator.calculateRentalYield'
  | 'tools.rentalYield.calculator.rentalYieldLabel'
  | 'tools.rentalYield.calculator.title'
  | 'tools.rentalYield.calculator.titleAdvanced'
  | 'tools.rentalYield.conclusion.description'
  | 'tools.rentalYield.conclusion.title'
  | 'tools.rentalYield.disclaimer.description'
  | 'tools.rentalYield.disclaimer.title'
  | 'tools.rentalYield.fields.expensesHint'
  | 'tools.rentalYield.fields.monthlyExpenses'
  | 'tools.rentalYield.fields.monthlyRent'
  | 'tools.rentalYield.fields.propertyPrice'
  | 'tools.rentalYield.howToChoose.description'
  | 'tools.rentalYield.howToChoose.title'
  | 'tools.rentalYield.howToChooseHighReturn.description'
  | 'tools.rentalYield.howToChooseHighReturn.title'
  | 'tools.rentalYield.howToUse.intro'
  | 'tools.rentalYield.howToUse.step1'
  | 'tools.rentalYield.howToUse.step2'
  | 'tools.rentalYield.howToUse.step3'
  | 'tools.rentalYield.howToUse.title'
  | 'tools.rentalYield.pageTitle'
  | 'tools.rentalYield.seo.description'
  | 'tools.rentalYield.seo.title'
  | 'tools.rentalYield.subtitle'
  | 'tools.stampDuty.advantages.points.0'
  | 'tools.stampDuty.advantages.points.1'
  | 'tools.stampDuty.advantages.points.2'
  | 'tools.stampDuty.advantages.points.3'
  | 'tools.stampDuty.advantages.points.4'
  | 'tools.stampDuty.advantages.title'
  | 'tools.stampDuty.averageYearlyRent'
  | 'tools.stampDuty.calculate'
  | 'tools.stampDuty.calculator.notice'
  | 'tools.stampDuty.calculator.title'
  | 'tools.stampDuty.endDate'
  | 'tools.stampDuty.explainer.blocks.0.body'
  | 'tools.stampDuty.explainer.blocks.0.heading'
  | 'tools.stampDuty.explainer.blocks.1.body'
  | 'tools.stampDuty.explainer.blocks.1.heading'
  | 'tools.stampDuty.explainer.blocks.2.body'
  | 'tools.stampDuty.explainer.blocks.2.heading'
  | 'tools.stampDuty.explainer.blocks.3.body'
  | 'tools.stampDuty.explainer.blocks.3.heading'
  | 'tools.stampDuty.explainer.blocks.4.body'
  | 'tools.stampDuty.explainer.blocks.4.heading'
  | 'tools.stampDuty.explainer.blocks.5.body'
  | 'tools.stampDuty.explainer.blocks.5.heading'
  | 'tools.stampDuty.explainer.title'
  | 'tools.stampDuty.faqs.list.0.answer'
  | 'tools.stampDuty.faqs.list.0.question'
  | 'tools.stampDuty.faqs.list.1.answer'
  | 'tools.stampDuty.faqs.list.1.question'
  | 'tools.stampDuty.faqs.list.2.answer'
  | 'tools.stampDuty.faqs.list.2.question'
  | 'tools.stampDuty.faqs.list.3.answer'
  | 'tools.stampDuty.faqs.list.3.question'
  | 'tools.stampDuty.faqs.list.4.answer'
  | 'tools.stampDuty.faqs.list.4.question'
  | 'tools.stampDuty.faqs.list.5.answer'
  | 'tools.stampDuty.faqs.list.5.question'
  | 'tools.stampDuty.faqs.list.6.answer'
  | 'tools.stampDuty.faqs.list.6.question'
  | 'tools.stampDuty.faqs.list.7.answer'
  | 'tools.stampDuty.faqs.list.7.question'
  | 'tools.stampDuty.faqs.title'
  | 'tools.stampDuty.fixedLease'
  | 'tools.stampDuty.howToUse.steps.0'
  | 'tools.stampDuty.howToUse.steps.1'
  | 'tools.stampDuty.howToUse.steps.2'
  | 'tools.stampDuty.howToUse.steps.3'
  | 'tools.stampDuty.howToUse.title'
  | 'tools.stampDuty.leaseType'
  | 'tools.stampDuty.monthlyRent'
  | 'tools.stampDuty.nonFixedLease'
  | 'tools.stampDuty.pageTitle'
  | 'tools.stampDuty.rates.basisAverageYearly'
  | 'tools.stampDuty.rates.basisHeader'
  | 'tools.stampDuty.rates.basisTotalRent'
  | 'tools.stampDuty.rates.counterpart'
  | 'tools.stampDuty.rates.intro'
  | 'tools.stampDuty.rates.rateHeader'
  | 'tools.stampDuty.rates.termAbove'
  | 'tools.stampDuty.rates.termBetween'
  | 'tools.stampDuty.rates.termHeader'
  | 'tools.stampDuty.rates.termNonFixed'
  | 'tools.stampDuty.rates.termUpTo'
  | 'tools.stampDuty.rates.title'
  | 'tools.stampDuty.related.buyVsRent'
  | 'tools.stampDuty.related.mortgage'
  | 'tools.stampDuty.related.ratesGovernmentRent'
  | 'tools.stampDuty.related.rentalYield'
  | 'tools.stampDuty.related.title'
  | 'tools.stampDuty.seo.description'
  | 'tools.stampDuty.seo.title'
  | 'tools.stampDuty.stampDutyPayable'
  | 'tools.stampDuty.startDate'
  | 'tools.stampDuty.subtitle'
  | 'tools.stampDuty.title'
  | 'transactions.area'
  | 'transactions.backToEstate'
  | 'transactions.date'
  | 'transactions.empty'
  | 'transactions.emptyEstate'
  | 'transactions.estate'
  | 'transactions.floor'
  | 'transactions.kind'
  | 'transactions.perSqft'
  | 'transactions.price'
  | 'transactions.recentDeals'
  | 'transactions.recentDealsNote'
  | 'transactions.seeAll'
  | 'transactions.source'
  | 'transactions.sqft'
  | 'transactions.subtitle'
  | 'transactions.unlinkedEstate'
  | 'wizard.address.buildingLabel'
  | 'wizard.address.buildingPlaceholder'
  | 'wizard.address.changeBuildingAction'
  | 'wizard.address.description'
  | 'wizard.address.estateLabel'
  | 'wizard.address.floor.label'
  | 'wizard.address.floor.placeholder'
  | 'wizard.address.floorLevel.higher'
  | 'wizard.address.floorLevel.hint'
  | 'wizard.address.floorLevel.label'
  | 'wizard.address.floorLevel.lower'
  | 'wizard.address.floorLevel.middle'
  | 'wizard.address.loadingBuildings'
  | 'wizard.address.manualEntryLink'
  | 'wizard.address.manualHint'
  | 'wizard.address.manualLabel'
  | 'wizard.address.manualPlaceholder'
  | 'wizard.address.manualReviewNote'
  | 'wizard.address.noBuildingsHint'
  | 'wizard.address.noBuildingsTitle'
  | 'wizard.address.otherPhasesAction'
  | 'wizard.address.phaseLabel'
  | 'wizard.address.phasePlaceholder'
  | 'wizard.address.search.clear'
  | 'wizard.address.search.emptyAction'
  | 'wizard.address.search.emptyHint'
  | 'wizard.address.search.emptyTitle'
  | 'wizard.address.search.errorHint'
  | 'wizard.address.search.errorTitle'
  | 'wizard.address.search.hint'
  | 'wizard.address.search.loading'
  | 'wizard.address.search.multiPhase'
  | 'wizard.address.search.placeholder'
  | 'wizard.address.searchLink'
  | 'wizard.address.structureErrorHint'
  | 'wizard.address.structureErrorTitle'
  | 'wizard.address.title'
  | 'wizard.address.unit.label'
  | 'wizard.address.unit.placeholder'
  | 'wizard.amenities.description'
  | 'wizard.amenities.title'
  | 'wizard.description.description'
  | 'wizard.description.hint'
  | 'wizard.description.label'
  | 'wizard.description.placeholder'
  | 'wizard.description.title'
  | 'wizard.errors.incomplete'
  | 'wizard.exitButton'
  | 'wizard.exitButtonIntro'
  | 'wizard.exitTooltip'
  | 'wizard.footer.back'
  | 'wizard.footer.next'
  | 'wizard.footer.publish'
  | 'wizard.media.add'
  | 'wizard.media.cover'
  | 'wizard.media.dropzone.subtitle'
  | 'wizard.media.photoAlt'
  | 'wizard.media.photosDone'
  | 'wizard.media.photosProgress'
  | 'wizard.media.rejected.tooLarge'
  | 'wizard.media.rejected.unsupportedType'
  | 'wizard.media.remove'
  | 'wizard.media.retry'
  | 'wizard.media.title'
  | 'wizard.media.uploadFailed'
  | 'wizard.payment.cancelled'
  | 'wizard.payment.checkAgain'
  | 'wizard.payment.confirming'
  | 'wizard.payment.expired'
  | 'wizard.payment.explainer'
  | 'wizard.payment.paid'
  | 'wizard.payment.payButton'
  | 'wizard.payment.pendingHint'
  | 'wizard.payment.publishButton'
  | 'wizard.payment.publishIncomplete'
  | 'wizard.payment.refunded'
  | 'wizard.payment.startError'
  | 'wizard.payment.statusError'
  | 'wizard.payment.title'
  | 'wizard.pricing.description'
  | 'wizard.pricing.forRentLabel'
  | 'wizard.pricing.forSaleLabel'
  | 'wizard.pricing.rentPriceLabel'
  | 'wizard.pricing.rentPricePlaceholder'
  | 'wizard.pricing.salePriceLabel'
  | 'wizard.pricing.salePricePlaceholder'
  | 'wizard.pricing.title'
  | 'wizard.size.bathroomsLabel'
  | 'wizard.size.bedroomsLabel'
  | 'wizard.size.description'
  | 'wizard.size.pets.hint'
  | 'wizard.size.pets.label'
  | 'wizard.size.pets.unspecified'
  | 'wizard.size.propertyType.hint'
  | 'wizard.size.propertyType.label'
  | 'wizard.size.propertyType.options.detachedHouse'
  | 'wizard.size.propertyType.options.estateFlat'
  | 'wizard.size.propertyType.options.publicHousing'
  | 'wizard.size.propertyType.options.servicedApartment'
  | 'wizard.size.propertyType.options.singleBlockFlat'
  | 'wizard.size.propertyType.options.subsidisedHos'
  | 'wizard.size.propertyType.options.tongLau'
  | 'wizard.size.propertyType.options.villageHouse'
  | 'wizard.size.propertyType.options.walkUp'
  | 'wizard.size.roomsHint'
  | 'wizard.size.saleableAreaLabel'
  | 'wizard.size.saleableAreaPlaceholder'
  | 'wizard.size.studio'
  | 'wizard.size.title'
  | 'wizard.toast.publishError'
  | 'wizard.toast.publishSuccess';

/** Valid relative keys for namespace `N`; `N = ''` (namespaceless) → every
 *  full key. An unknown namespace falls back to `string`. */
export type MessageKeys<N extends string> =
  N extends '' ? AllMessageKeys
  : N extends keyof MessageKeysByNamespace ? MessageKeysByNamespace[N] : string;

/**
 * The closed index vocabulary of every INDEXED message family — array
 * values (`a.b` → `a.b.0`, `a.b.0.field`) and numeric-suffix families
 * (`a.category` → `a.category1`), as fixed-length readonly tuples.
 *
 * Read it through `t.indices(family)`, never by hand: the tuple element type
 * is a union of LITERAL indices, so `t.dyn(`a.b.${i}`)` over it resolves to
 * real catalog keys and cannot run past the end of the catalog.
 */
// prettier-ignore
export const MESSAGE_INDICES = {
  'forms.disclaimer.paragraphs': [0, 1, 2],
  'home.hero.searchExamples': [0, 1, 2, 3, 4],
  'listings.new.steps': [0, 1, 2],
  'schoolsAndRentals.faqs.list': [0, 1, 2, 3, 4],
  'schoolsAndRentals.whyChoose.details': [0, 1, 2],
  'services.buyRent.assisted.features': [0, 1, 2],
  'services.buyRent.self.features': [0, 1, 2],
  'services.faqs.list': [0, 1, 2, 3],
  'services.sellLease.assisted.features': [0, 1, 2],
  'services.sellLease.self.features': [0, 1, 2],
  'services.socialProof.testimonials': [0, 1, 2, 3, 4],
  'tools.affordability.advantages.points': [0, 1, 2, 3],
  'tools.affordability.explainer.blocks': [0, 1, 2, 3],
  'tools.affordability.faqs.list': [0, 1, 2, 3, 4, 5],
  'tools.affordability.howToUse.steps': [0, 1, 2, 3],
  'tools.chineseConverter.advantages.point': [1, 2, 3, 4],
  'tools.chineseConverter.footerNote.p': [1, 2],
  'tools.chineseConverter.howToUse.step': [1, 2, 3, 4],
  'tools.mortgage.advantages.points': [0, 1, 2, 3, 4],
  'tools.mortgage.explainer.blocks': [0, 1, 2, 3, 4, 5, 6],
  'tools.mortgage.faqs.list': [0, 1, 2, 3, 4, 5, 6, 7],
  'tools.mortgage.howToUse.steps': [0, 1, 2, 3],
  'tools.ratesGovernmentRent.calculation.rates.fourthQuarterStep': [1, 2, 3],
  'tools.ratesGovernmentRent.calculator.totalQuarter': [1, 2, 3, 4],
  'tools.ratesGovernmentRent.exemptions.category': [1, 2, 3, 4, 5, 6],
  'tools.ratesGovernmentRent.howToUse.step': [1, 2, 3],
  'tools.ratesGovernmentRent.schedule.header': [1, 2, 3],
  'tools.ratesGovernmentRent.schedule.rows.q': [1, 2, 3, 4],
  'tools.ratesGovernmentRent.whyUse.step': [1, 2, 3, 4, 5],
  'tools.rentalYield.howToUse.step': [1, 2, 3],
  'tools.stampDuty.advantages.points': [0, 1, 2, 3, 4],
  'tools.stampDuty.explainer.blocks': [0, 1, 2, 3, 4, 5],
  'tools.stampDuty.faqs.list': [0, 1, 2, 3, 4, 5, 6, 7],
  'tools.stampDuty.howToUse.steps': [0, 1, 2, 3],
} as const;

/** Every indexed message family (the key of {@link MESSAGE_INDICES}). */
export type MessageIndexFamily = keyof typeof MESSAGE_INDICES;

/** Any value an ICU `{placeholder}` accepts (a non-format-typed argument). */
type IcuPrimitive = string | number | boolean | Date;

/**
 * Per fully-qualified message key → the ICU arguments it REQUIRES. Keys that
 * take no arguments are intentionally omitted (they fall through to the empty
 * args type below). Used by `useTranslations` to check `t(key, values)`.
 */
// prettier-ignore
export interface MessageArgsByKey {
  'auth.otp.codeSentTo': { phone: IcuPrimitive };
  'auth.shared.continueWithProvider': { provider: IcuPrimitive };
  'blog.byAuthor': { author: IcuPrimitive };
  'blog.categoryChip': { count: IcuPrimitive; name: IcuPrimitive };
  'blog.noPostsForSearch': { query: IcuPrimitive };
  'error.auth.alreadyLinked': { provider: IcuPrimitive };
  'estates.card.blocks': { count: IcuPrimitive };
  'estates.card.forRent': { count: IcuPrimitive };
  'estates.card.forSale': { count: IcuPrimitive };
  'estates.detail.buildingsCount': { count: IcuPrimitive };
  'estates.detail.census.dataSource': { year: IcuPrimitive };
  'estates.detail.census.genderHeading': { district: IcuPrimitive };
  'estates.detail.census.heading': { year: IcuPrimitive };
  'estates.detail.ctaTitle': { name: IcuPrimitive };
  'estates.detail.facts.poi.value': { distance: IcuPrimitive; name: IcuPrimitive };
  'estates.detail.gallery.viewAll': { count: IcuPrimitive };
  'estates.detail.listingCount': { count: number };
  'estates.detail.nearbyRentListings': { name: IcuPrimitive };
  'estates.detail.nearbySaleListings': { name: IcuPrimitive };
  'estates.detail.photoAlt': { index: IcuPrimitive; name: IcuPrimitive };
  'estates.detail.priceTrend.samples': { count: IcuPrimitive };
  'estates.detail.rentListings': { name: IcuPrimitive };
  'estates.detail.saleListings': { name: IcuPrimitive };
  'estates.districtFacet.about.buy': { count: number; district: IcuPrimitive; region: IcuPrimitive };
  'estates.districtFacet.about.rent': { count: number; district: IcuPrimitive; region: IcuPrimitive };
  'estates.districtFacet.aboutEmpty.buy': { district: IcuPrimitive; region: IcuPrimitive };
  'estates.districtFacet.aboutEmpty.rent': { district: IcuPrimitive; region: IcuPrimitive };
  'estates.districtFacet.aboutHeading': { district: IcuPrimitive };
  'estates.districtFacet.backToHub': { district: IcuPrimitive };
  'estates.districtFacet.buyLink': { district: IcuPrimitive };
  'estates.districtFacet.guidance.buy': { district: IcuPrimitive };
  'estates.districtFacet.guidance.rent': { district: IcuPrimitive };
  'estates.districtFacet.nearbyBuy': { region: IcuPrimitive };
  'estates.districtFacet.nearbyRent': { region: IcuPrimitive };
  'estates.districtFacet.population': { district: IcuPrimitive; population: IcuPrimitive; year: IcuPrimitive };
  'estates.districtFacet.rentLink': { district: IcuPrimitive };
  'estates.noneForSearch': { query: IcuPrimitive };
  'estates.showing': { count: IcuPrimitive };
  'listings.browse.propertyCount': { count: number };
  'listings.card.bathrooms': { count: number };
  'listings.card.bedrooms': { count: number };
  'listings.card.sqft': { area: IcuPrimitive };
  'listings.detail.bathrooms': { count: number };
  'listings.detail.bedrooms': { count: number };
  'listings.editor.morePhotos': { count: IcuPrimitive };
  'listings.filters.buttonLabelWithCount': { count: IcuPrimitive };
  'listings.filters.showResults': { count: IcuPrimitive };
  'listings.gallery.morePhotos': { count: IcuPrimitive };
  'market.sourceLine': { source: IcuPrimitive };
  'pager.gotoPage': { page: IcuPrimitive };
  'pager.pageOf': { page: IcuPrimitive; total: IcuPrimitive };
  'partners.directory.count': { count: number };
  'partners.directory.roles': { roles: IcuPrimitive };
  'partners.postsByPartner': { partner: IcuPrimitive };
  'saved.subtitle': { count: IcuPrimitive };
  'search.rentCount': { count: number };
  'search.saleCount': { count: number };
  'search.suggestions.emptyTitle': { query: IcuPrimitive };
  'tools.affordability.explainer.blocks.0.body': { dsr: IcuPrimitive; ltv: IcuPrimitive };
  'tools.affordability.explainer.blocks.3.body': { dsr: IcuPrimitive; ltv: IcuPrimitive };
  'tools.affordability.results.boundByDeposit': { ltv: IcuPrimitive };
  'tools.affordability.results.boundByIncome': { dsr: IcuPrimitive };
  'tools.buyVsRent.breakevenMessage': { years: IcuPrimitive };
  'tools.chineseConverter.converter.fieldLabel': { field: IcuPrimitive; qualifier: IcuPrimitive };
  'tools.mortgage.explainer.blocks.1.body': { ltv: IcuPrimitive };
  'tools.mortgage.explainer.blocks.1.heading': { ltv: IcuPrimitive };
  'tools.mortgage.explainer.blocks.2.body': { dsr: IcuPrimitive };
  'tools.mortgage.explainer.blocks.2.heading': { dsr: IcuPrimitive };
  'tools.stampDuty.explainer.blocks.4.body': { nonFixed: IcuPrimitive };
  'tools.stampDuty.rates.termAbove': { years: IcuPrimitive };
  'tools.stampDuty.rates.termBetween': { from: IcuPrimitive; to: IcuPrimitive };
  'tools.stampDuty.rates.termUpTo': { years: IcuPrimitive };
  'transactions.backToEstate': { estate: IcuPrimitive };
  'transactions.sqft': { area: IcuPrimitive };
  'wizard.address.otherPhasesAction': { development: IcuPrimitive };
  'wizard.address.search.emptyTitle': { query: IcuPrimitive };
  'wizard.media.dropzone.subtitle': { maxMb: IcuPrimitive };
  'wizard.media.photosDone': { done: IcuPrimitive };
  'wizard.media.photosProgress': { done: IcuPrimitive; min: IcuPrimitive; remaining: IcuPrimitive };
  'wizard.media.rejected.tooLarge': { maxMb: IcuPrimitive; name: IcuPrimitive };
  'wizard.media.rejected.unsupportedType': { name: IcuPrimitive };
  'wizard.payment.explainer': { amount: IcuPrimitive };
  'wizard.payment.payButton': { amount: IcuPrimitive };
}

/**
 * The args object for a message key — `Record<string, never>` (no required
 * args) when the key takes none, otherwise its typed argument shape.
 */
export type MessageArgs<FullKey extends string> =
  FullKey extends keyof MessageArgsByKey ? MessageArgsByKey[FullKey] : Record<string, never>;
